{
  "app": {
    "newUpdateAvailable": "Nouvelle mise à jour disponible",
    "newUpdateAvailableDescription": "Veuillez recharger l'application pour obtenir la dernière version",
    "reloadApp": "Recharger l'application",
    "cancel": "Annuler",
    "error": {
      "title": "Quelque chose s'est mal passé",
      "message": "Une erreur inattendue s'est produite. Veuillez réessayer.",
      "takeMeHome": "Retour à l'accueil"
    },
    "sessionExpired": {
      "title": "Session expirée",
      "message": "Votre session a expiré. Veuillez vous reconnecter.",
      "ok": "OK"
    }
  },
  "ExpoUpdateBottomSheet": {
    "title": "Une nouvelle mise à jour est disponible",
    "description": "Mettez à jour maintenant pour obtenir les dernières fonctionnalités, améliorations et corrections de bugs.",
    "apply": "Mettre à jour",
    "cancel": "Annuler"
  },
  "BetaEndedModal": {
    "title": "La bêta est terminée",
    "body": "Merci beaucoup d'avoir participé à la bêta de Squire ! Nous espérons que vous avez apprécié cet aperçu.",
    "reassurance": "Ne vous inquiétez pas : vous ne perdrez aucune de vos données.",
    "downloadButtonIos": "Télécharger depuis l'App Store",
    "downloadButtonAndroid": "Télécharger depuis Google Play",
    "accessibility": {
      "downloadButtonHint": "Ouvre la fiche de l'application sur le store"
    }
  },
  "DevMenu": {
    "title": "Paramètres développeur",
    "buttonLabel": "😛",
    "clearStorage": "Effacer le stockage",
    "testErrorBoundary": "Tester la limite d'erreur",
    "triggerNPSSurvey": "Déclencher le sondage NPS",
    "triggerAppStoreReview": "Déclencher l'avis App Store",
    "triggerRatingPrompt": "Déclencher l'invite d'évaluation",
    "environment": "Environnement",
    "bnplVariant": "Variante de paiement BNPL",
    "bnplVariantFromLaunchDarkly": "Utiliser LaunchDarkly",
    "bnplVariantControl": "Contrôle",
    "bnplVariantPayLater": "Payer plus tard",
    "bnplVariantNowLater": "Payer maintenant / plus tard",
    "depositMock": "Simuler l'acompte de réservation",
    "depositMockOff": "Désactivé",
    "depositMockRefundable": "Remboursable",
    "depositMockNonRefundable": "Non remboursable",
    "appId": "ID de l'application",
    "appVersion": "Version de l'application",
    "runtimeVersion": "Version d'exécution",
    "appearance": "Apparence",
    "light": "Clair",
    "dark": "Sombre",
    "language": "Langue",
    "actions": "Actions",
    "toasts": "Toasts",
    "toastSuccess": "Toast de succès",
    "toastError": "Toast d'erreur",
    "toastInfo": "Toast d'information",
    "toastLong": "Toast long",
    "toastSuccessMessage": "Votre rendez-vous est réservé",
    "toastErrorMessage": "Nous n'avons pas pu traiter votre paiement",
    "toastInfoMessage": "Votre barbier a quelques minutes de retard",
    "toastLongMessage": "Nous n'avons pas pu réserver ce créneau, car un autre client vient de le prendre. Veuillez choisir un autre créneau.",
    "toastLongDescription": "Votre carte n'a pas été débitée."
  },
  "shared": {
    "locationPermission": {
      "denied": "L'accès à la localisation a été refusé",
      "openSettings": "Ouvrir les paramètres"
    },
    "photoPermission": {
      "cameraDenied": "L'accès à la caméra a été refusé",
      "libraryDenied": "L'accès à la bibliothèque de photos a été refusé",
      "openSettings": "Ouvrir les paramètres"
    },
    "openDirections": {
      "title": "Ouvrir dans Plans",
      "description": "Choisissez votre application de cartes préférée",
      "cancel": "Annuler"
    },
    "resendOtpButton": {
      "resendCode": "Renvoyer le code",
      "resendIn": "Renvoyer dans {{seconds}} s",
      "didNotReceiveCode": "Vous n'avez rien reçu ? Réessayez.",
      "accessibility": {
        "resendSection": "Options de renvoi du code",
        "resendButton": "Renvoyer le code de vérification",
        "resendButtonHint": "Demander l'envoi d'un nouveau code de vérification sur votre téléphone"
      }
    },
    "otpInput": {
      "accessibility": {
        "label": "Saisie du code de vérification",
        "hint": "Entrez le code de vérification"
      }
    },
    "screenHeader": {
      "backButton": {
        "accessibilityLabel": "Retour",
        "accessibilityHint": "Retourner à l'écran précédent"
      },
      "closeButton": {
        "accessibilityLabel": "Fermer",
        "accessibilityHint": "Fermer et retourner à l'écran précédent"
      },
      "widgetCloseButton": {
        "accessibilityLabel": "Fermer le widget",
        "accessibilityHint": "Fermer le widget de réservation"
      },
      "languageButton": {
        "accessibilityLabel": "Changer de langue",
        "accessibilityHint": "Ouvre le sélecteur de langue"
      }
    },
    "validation": {
      "emailRequired": "L'email est requis",
      "emailInvalid": "Veuillez entrer une adresse email valide"
    }
  },
  "HomeDrawer": {
    "greeting": "Salut, {{name}}",
    "viewProfile": "Voir le profil",
    "appointments": "Rendez-vous",
    "standby": "Liste d'attente",
    "cards": "Cartes",
    "terms": "Conditions",
    "privacy": "Confidentialité",
    "support": "Support",
    "language": "Langue",
    "signOut": "Se déconnecter",
    "accessibility": {
      "closeDrawer": "Fermer le menu",
      "profileSection": "Section profil utilisateur",
      "profileButton": "Voir le profil",
      "profileButtonHint": "Accéder à votre page de profil",
      "menuSection": "Options du menu principal",
      "appointmentsButton": "Voir les rendez-vous",
      "appointmentsButtonHint": "Accéder à vos rendez-vous",
      "standbyButton": "Liste d'attente, {{count}} active(s)",
      "standbyButtonHint": "Accéder à votre liste d'attente",
      "cardsButton": "Gérer les cartes",
      "cardsButtonHint": "Accéder à vos cartes enregistrées",
      "termsButton": "Voir les conditions générales",
      "termsButtonHint": "Ouvrir les conditions d'utilisation",
      "privacyButton": "Voir la politique de confidentialité",
      "privacyButtonHint": "Ouvrir la politique de confidentialité",
      "supportButton": "Obtenir de l'aide et du support",
      "supportButtonHint": "Contacter le support client",
      "languageButton": "Langue",
      "languageButtonHint": "Changer la langue de l'application",
      "signOutButton": "Se déconnecter de votre compte",
      "signOutButtonHint": "Se déconnecter de l'application",
      "closeDrawerHint": "Ferme le menu"
    }
  },
  "CardsScreen": {
    "title": "Cartes",
    "emptyTitle": "Vous n'avez aucune carte enregistrée",
    "invalidCard": "La carte n'est plus valide",
    "applePay": "Apple Pay",
    "expires": "Expire le {{date}}",
    "error": "Impossible de charger les cartes",
    "tryAgain": "Réessayer",
    "setDefaultSuccess": "Moyen de paiement par défaut mis à jour",
    "setDefaultErrorTitle": "Impossible de mettre à jour votre carte par défaut",
    "setDefaultErrorDescription": "Veuillez réessayer.",
    "removeCard": "Supprimer",
    "removeCardError": "Impossible de supprimer la carte. Veuillez réessayer.",
    "removeCardErrorMarkedDefault": "Définissez une autre carte par défaut avant de supprimer celle-ci.",
    "removeCardErrorAttachedToAppointment": "Cette carte ne peut pas être supprimée car elle est associée à un rendez-vous à venir.",
    "removeCardErrorUnfinishedSale": "Cette carte est utilisée pour un paiement en cours de traitement. Vous pourrez la supprimer une fois celui-ci terminé.",
    "addCard": "Ajouter une nouvelle carte",
    "addCardTitle": "Ajouter une nouvelle carte",
    "cardLabel": "Carte",
    "makeDefault": "Définir par défaut",
    "addCardConfirm": "Ajouter la carte",
    "addCardError": "Votre carte n'a pas pu être ajoutée. Vérifiez les informations ou essayez une autre carte.",
    "addCardSuccess": "La carte a été ajoutée avec succès",
    "cardLimitNotice": "Vous pouvez enregistrer jusqu'à {{limit}} cartes, faites glisser une carte vers la gauche pour la supprimer.",
    "accessibility": {
      "card": "Carte se terminant par {{last4}}",
      "removeCard": "Supprimer la carte se terminant par {{last4}}"
    }
  },
  "RouteAnnouncer": {
    "chooseLocation": "Choisir un emplacement",
    "chooseProfessional": "Choisir un professionnel",
    "chooseService": "Choisir un service",
    "chooseTime": "Choisir un horaire",
    "buyGiftCard": "Acheter une carte cadeau"
  },
  "WaitingRoom": {
    "title": "SQUIRE est momentanément indisponible.",
    "message": "Dès que le service sera de nouveau disponible, vous serez admis automatiquement...",
    "contactSupport": "Contacter le support",
    "closeButton": {
      "accessibilityLabel": "Fermer le widget",
      "accessibilityHint": "Fermer le widget de réservation"
    }
  },
  "LanguageBottomSheet": {
    "title": "Langue",
    "english": "English",
    "spanish": "Español",
    "french": "Français",
    "englishShort": "EN",
    "spanishShort": "ES",
    "frenchShort": "FR",
    "currentLanguage": "Langue actuelle : {{language}}",
    "confirmButton": "Confirmer la langue",
    "languageUpdateError": "Nous n'avons pas pu mettre à jour votre langue. Veuillez réessayer.",
    "languageNames": {
      "english": "Anglais",
      "spanish": "Espagnol",
      "french": "Français"
    },
    "accessibility": {
      "closeButton": "Fermer la sélection de langue",
      "closeButtonHint": "Ferme la sélection de langue",
      "selectLanguageHint": "Sélectionner {{language}} comme langue de l'application",
      "confirmButton": "Confirmer la sélection de langue",
      "confirmButtonHint": "Appliquer la langue sélectionnée à l'application",
      "radioButton": "Bouton de sélection de {{language}}",
      "radioButtonSelected": "{{language}} est actuellement sélectionné"
    }
  },
  "AuthScreen": {
    "errorTitle": "Erreur",
    "title": "Créer un compte\nou Se connecter",
    "continueWithApple": "Continuer avec Apple",
    "continueWithAppleLabel": "Continuer avec Apple",
    "or": "OU",
    "ok": "OK",
    "signUp": "S'inscrire",
    "signIn": "Se connecter",
    "close": "Fermer",
    "dataUsageInfo": "En continuant, vous acceptez nos Conditions d'utilisation et notre Politique de confidentialité",
    "appleSignInError": "La connexion avec Apple a échoué. Veuillez réessayer.",
    "accessibility": {
      "closeButton": "Fermer l'écran d'authentification",
      "closeButtonHint": "Retourner à l'écran précédent",
      "authIcon": "Icône d'authentification",
      "appleSignInButton": "Continuer avec Apple",
      "appleSignInButtonHint": "Se connecter avec votre identifiant Apple",
      "googleSignInButton": "Continuer avec Google",
      "googleSignInButtonHint": "Se connecter avec votre compte Google",
      "signUpButton": "Créer un nouveau compte",
      "signUpButtonHint": "Accéder au processus d'inscription",
      "signInButton": "Se connecter par email",
      "signInButtonHint": "Accéder au processus de connexion par email",
      "separator": "Séparateur OU",
      "screen": "Écran d'authentification",
      "methods": "Méthodes d'authentification",
      "loading": "Connexion en cours"
    },
    "continueWithGoogle": "Continuer avec Google",
    "continueWithGoogleLabel": "Continuer avec Google",
    "signingInWithGoogle": "Connexion avec Google..."
  },
  "LoginScreen": {
    "title": "Bienvenue !",
    "signInToContinue": "Connectez-vous pour continuer",
    "email": "Email",
    "enterYourEmail": "Entrez votre email",
    "password": "Mot de passe",
    "enterYourPassword": "Entrez votre mot de passe",
    "signIn": "Se connecter"
  },
  "HomeScreen": {
    "welcome": "Bienvenue chez Squire,\ntrouvez un salon de coiffure près de chez vous.",
    "signIn": "S'inscrire / Se connecter",
    "logIn": "Se connecter",
    "giveFeedback": "Donner votre avis",
    "nearby": "À PROXIMITÉ",
    "search": "RECHERCHER",
    "book": "Réserver",
    "haveAppointment": "J'ai un rendez-vous",
    "openSupportEmailError": "Erreur lors de l'ouverture de l'email de support",
    "noEmailAppError": "Aucune application de messagerie n'a été trouvée sur cet appareil. Veuillez installer une application de messagerie pour contacter le support.",
    "seeMore": "Vous voulez en voir plus ?\nParcourir les salons",
    "location": "Localisation",
    "locationDescription": "Nous avons besoin de votre localisation pour trouver des salons près de chez vous",
    "continue": "Continuer",
    "title": "Choisir un emplacement",
    "searchPlaceholder": "Rechercher des salons, coiffeurs ou marques",
    "locationSearchPlaceholder": "Entrer une localisation",
    "locationSearchNotice": "La vue carte n’est pas disponible dans cette version. Vous pouvez toujours parcourir les établissements à proximité ci-dessous.",
    "getDirections": "Obtenir l'itinéraire",
    "noResults": "Aucun résultat trouvé",
    "noResultsDescription": "Essayez d'ajuster vos termes de recherche ou vérifiez l'orthographe",
    "startSearching": "Commencez à taper pour rechercher",
    "startSearchingDescription": "Rechercher des salons, coiffeurs\nou marques dans votre région",
    "noOtherLocations": "Aucun autre établissement",
    "noOtherLocationsDescription": "Cette marque n'a aucun autre établissement\nvers lequel déplacer cette réservation",
    "location_one": "{{count}} emplacement",
    "location_other": "{{count}} emplacements",
    "searchResults": "RÉSULTATS DE RECHERCHE",
    "noResultsFound": "Aucun résultat trouvé. Essayez\navec un terme différent.",
    "accessibility": {
      "menuButton": "Ouvrir le menu",
      "menuButtonHint": "Ouvre le menu de navigation principal",
      "signInButton": "Se connecter",
      "signInButtonHint": "Se connecter à votre compte",
      "giveFeedbackButton": "Donner votre avis",
      "giveFeedbackButtonHint": "Ouvre un e-mail pour partager vos commentaires sur l'application bêta",
      "welcomeMessage": "Message de bienvenue",
      "nearbyButton": "{{count}} salons à proximité",
      "nearbyButtonActive": "Désactiver la recherche à proximité",
      "nearbyButtonInactive": "Trouver des salons près de votre localisation",
      "searchButton": "{{count}} salons",
      "searchButtonHint": "Rechercher des salons, coiffeurs ou marques",
      "dismissLocationSearchNotice": "Fermer l'avis",
      "searchResultButton": "Résultat de recherche : {{searchTerm}}",
      "searchResultButtonHint": "Effacer la recherche et revenir à tous les salons",
      "clearSearchButton": "Effacer la recherche",
      "clearSearchButtonHint": "Supprimer le filtre de recherche actuel",
      "appointmentButton": "J'ai un rendez-vous",
      "appointmentButtonHint": "Voir vos rendez-vous existants",
      "barbershopCard": "{{name}}, situé à {{address}}, à environ {{distance}}",
      "barbershopCardHint": "Réserver un rendez-vous dans ce salon",
      "barbershopPhoto": "Photo de {{name}}",
      "bookButton": "Réserver un rendez-vous chez {{name}}",
      "bookButtonHint": "Planifier un rendez-vous dans ce salon",
      "carouselList": "{{count}} salons",
      "carouselListHint": "Balayez horizontalement pour parcourir les salons",
      "seeMoreButton": "Voir plus de salons",
      "seeMoreButtonHint": "Parcourir plus de salons"
    },
    "betaFeedbackEmail": {
      "subject": "Squire iOS Beta Feedback — {{appVersion}} (Build {{buildNumber}})",
      "descriptionPrompt": "De quoi s'agit-il ?",
      "descriptionPlaceholder": "[Appuyez ici pour décrire ce qui s'est passé]",
      "reproStepsLabel": "Étapes pour reproduire (le cas échéant) :",
      "expectedLabel": "Qu'attendiez-vous qu'il se passe ?",
      "actualLabel": "Que s'est-il réellement passé ?",
      "screenshotPrompt": "Veuillez joindre une capture d'écran si possible — cela aide beaucoup !",
      "diagnosticsLabel": "Auto-included:",
      "deviceLabel": "Device",
      "appVersionLabel": "App Version",
      "buildNumberLabel": "Build Number",
      "userIdLabel": "User ID",
      "timestampLabel": "Timestamp"
    }
  },
  "PasswordRequirements": {
    "length": "Au moins 8 caractères",
    "letter": "Doit contenir une lettre",
    "specialChar": "Un chiffre ou caractère spécial"
  },
  "SignUpAvatarScreen": {
    "title": "Une dernière chose",
    "subtitle": "Configurez votre photo de profil\nsi vous le souhaitez.",
    "avatarPlaceholder": "[L'interface de sélection d'avatar sera implémentée ici]",
    "selectAvatar": "Sélectionner une photo",
    "skip": "Je le ferai plus tard",
    "uploadError": {
      "title": "Échec du téléchargement",
      "message": "Échec du téléchargement de votre photo de profil. Veuillez réessayer.",
      "noCustomerId": "Impossible de télécharger la photo pour le moment. Veuillez réessayer plus tard."
    },
    "galleryError": {
      "title": "Erreur de galerie",
      "message": "Échec de la sélection de la photo. Veuillez réessayer."
    },
    "accessibility": {
      "selectAvatarButton": "Sélectionner une photo de profil",
      "selectAvatarButtonHint": "Choisir une photo pour votre profil",
      "skipButton": "Ignorer l'ajout de photo",
      "skipButtonHint": "Continuer sans ajouter de photo de profil",
      "screen": "Écran de sélection d'avatar"
    }
  },
  "SignUpEmailScreen": {
    "title": "Créer un compte",
    "subtitle": "Créer un compte",
    "email": "EMAIL",
    "emailLabel": "EMAIL",
    "emailPlaceholder": "Entrez votre email",
    "password": "MOT DE PASSE",
    "passwordLabel": "MOT DE PASSE",
    "passwordPlaceholder": "Entrez votre mot de passe",
    "continue": "Continuer",
    "accessibility": {
      "closeButton": "Fermer le processus d'inscription",
      "closeButtonHint": "Retourner à l'écran précédent",
      "emailInput": "Adresse email",
      "passwordInput": "Mot de passe",
      "showPasswordButton": "Afficher le mot de passe",
      "hidePasswordButton": "Masquer le mot de passe",
      "continueButton": "Continuer à l'étape suivante",
      "continueButtonHint": "Procéder à la saisie des détails personnels"
    }
  },
  "SignUpSecondStepScreen": {
    "title": "Deuxième étape",
    "subtitle": "Parlez-nous un peu plus\nde vous...",
    "firstNameLabel": "PRÉNOM",
    "firstNamePlaceholder": "Prénom",
    "lastNameLabel": "NOM",
    "lastNamePlaceholder": "Nom",
    "phoneLabel": "TÉLÉPHONE",
    "phonePlaceholder": "+33 6 12 34 56 78",
    "phoneDescription": "Nous vous enverrons un code de vérification par SMS",
    "continue": "Continuer",
    "close": "Fermer",
    "creatingAccount": "Création du compte...",
    "errorTitle": "Erreur",
    "validation": {
      "firstNameRequired": "Le prénom est requis",
      "firstNameInvalid": "Le prénom ne peut pas contenir de chiffres",
      "lastNameRequired": "Le nom est requis",
      "lastNameInvalid": "Le nom ne peut pas contenir de chiffres",
      "phoneInvalid": "Veuillez entrer un numéro de téléphone valide"
    },
    "errors": {
      "emailExists": "Un compte avec cet email existe déjà. Veuillez vous connecter.",
      "invalidPhone": "Veuillez entrer un numéro de téléphone valide",
      "general": "Une erreur s'est produite. Veuillez réessayer."
    },
    "accessibility": {
      "backButton": "Retour",
      "backButtonHint": "Retourner à l'étape précédente",
      "closeButton": "Fermer le processus d'inscription",
      "closeButtonHint": "Annuler le processus d'inscription",
      "firstNameInput": "Prénom",
      "lastNameInput": "Nom",
      "phoneInput": "Numéro de téléphone avec indicatif pays",
      "phoneInputHint": "Inclure l'indicatif pays, ex: +33 pour la France",
      "continueButton": "Créer le compte et continuer",
      "continueButtonHint": "Crée votre compte et envoie le code de vérification"
    }
  },
  "SignUpOtpScreen": {
    "title": "Veuillez vérifier",
    "subtitle": "Nous avons envoyé un code de vérification à 6 chiffres au numéro se terminant par {{phone}}",
    "otpLabel": "CODE À 6 CHIFFRES",
    "otpCode": "Code",
    "resendCode": "Renvoyer le code",
    "didNotReceiveCode": "Vous n'avez rien reçu ? Réessayez.",
    "codeSent": "Code envoyé",
    "validCode": "Code vérifié",
    "invalidCode": "Code invalide",
    "accessibility": {
      "backButton": "Retour",
      "backButtonHint": "Retourner à l'étape précédente",
      "closeButton": "Fermer l'inscription",
      "closeButtonHint": "Annuler le processus d'inscription",
      "otpInput": "Code de vérification à 6 chiffres",
      "otpInputHint": "Entrez le code de vérification à 6 chiffres envoyé sur votre téléphone",
      "verifyButton": "Vérifier le code et continuer",
      "verifyButtonHint": "Vérifie votre numéro de téléphone et passe à l'étape suivante",
      "resendButton": "Renvoyer le code de vérification",
      "resendButtonHint": "Demander l'envoi d'un nouveau code de vérification sur votre téléphone",
      "resendSection": "Options de renvoi du code",
      "phoneNumber": "Code envoyé à {{phone}}",
      "otpForm": "Formulaire de code de vérification"
    }
  },
  "SignUpConfirmationScreen": {
    "title": "C'est bon !",
    "subtitle": "Vous êtes prêt à voir\nvotre écran d'accueil.",
    "continue": "Commencer",
    "accessibility": {
      "successIcon": "Création de compte réussie",
      "continueButton": "Continuer vers l'application",
      "continueButtonHint": "Accéder à l'application principale",
      "screen": "Écran de confirmation d'inscription"
    }
  },
  "SignInEmailScreen": {
    "title": "Se connecter",
    "subtitle": "Connectez-vous à votre compte\navec votre adresse email",
    "emailLabel": "EMAIL",
    "emailPlaceholder": "Entrez votre email",
    "submitButton": "Soumettre",
    "emailNotFound": "Ce compte n'existe pas. Créez un compte ou utilisez une autre adresse email.",
    "accessibility": {
      "emailInput": "Champ de saisie d'adresse email",
      "emailInputHint": "Entrez l'adresse email associée à votre compte",
      "submitButton": "Soumettre l'email pour vérification",
      "submitButtonHint": "Envoyer le code de vérification au numéro de téléphone enregistré",
      "screen": "Écran de connexion par email"
    }
  },
  "SignInOtpScreen": {
    "title": "Se connecter",
    "subtitle": "Nous avons envoyé un code de vérification à 6 chiffres au numéro se terminant par {{phone}}",
    "subtitleEmail": "Nous avons envoyé un code de vérification à 6 chiffres à votre adresse e-mail",
    "otpCode": "Code",
    "otpLabel": "CODE À 6 CHIFFRES",
    "codeSent": "Code envoyé",
    "resendCode": "Renvoyer le code",
    "didNotReceiveCode": "Vous n'avez rien reçu ? Réessayez.",
    "validCode": "Code vérifié",
    "networkError": "Une erreur s'est produite. Veuillez réessayer.",
    "invalidCode": "Code invalide",
    "accessibility": {
      "phoneNumber": "Code envoyé au numéro se terminant par {{phone}}",
      "emailAddress": "Code envoyé à votre adresse e-mail",
      "otpForm": "Formulaire de code de vérification",
      "otpInput": "Saisie du code de vérification à 6 chiffres",
      "otpInputHint": "Entrez le code de vérification à 6 chiffres envoyé sur votre téléphone",
      "resendButton": "Renvoyer le code de vérification",
      "resendButtonHint": "Demander l'envoi d'un nouveau code de vérification sur votre téléphone",
      "resendSection": "Options de renvoi du code",
      "screen": "Écran de vérification de connexion"
    }
  },
  "AccountDisabledScreen": {
    "title": "Le compte est désactivé",
    "subtitle": "Si vous souhaitez vous connecter à votre compte, soumettez une demande de restauration",
    "disabledOn": "Désactivé le {{date}}",
    "restoreAction": "Restaurer le compte",
    "cancelAction": "Annuler",
    "restoreEmail": {
      "subject": "Restaurer le compte",
      "bodyPrefix": "Veuillez restaurer mon compte avec les informations suivantes :\nIdentifiant utilisateur : {{userId}}"
    },
    "accessibility": {
      "screen": "Écran de compte désactivé",
      "avatar": "Avatar de l'utilisateur",
      "restoreButton": "Restaurer le compte",
      "restoreButtonHint": "Ouvre le courriel de support pour demander la restauration du compte",
      "cancelButton": "Annuler",
      "cancelButtonHint": "Retour à la connexion"
    }
  },
  "LookUpScreen": {
    "title": "Rechercher",
    "subtitle": "Entrez votre code de confirmation de rendez-vous à 6 chiffres.",
    "invalidCode": "Le code de confirmation ou l'identifiant fourni est invalide.",
    "networkError": "Erreur réseau. Veuillez réessayer.",
    "loading": "Recherche du rendez-vous...",
    "otpLabel": "CODE À 6 CHIFFRES",
    "accessibility": {
      "otpInput": "Saisie du code de confirmation de rendez-vous",
      "otpInputHint": "Entrez votre code de confirmation de rendez-vous à 6 chiffres",
      "lookupForm": "Formulaire de recherche de rendez-vous",
      "closeButton": "Fermer l'écran de recherche de rendez-vous",
      "closeButtonHint": "Retourner à l'écran précédent"
    }
  },
  "AppointmentHomeScreen": {
    "signIn": "Se connecter",
    "viewMore": "Voir plus",
    "bookAgain": "Réserver à nouveau",
    "bookNew": "Réserver un nouveau rendez-vous",
    "withBarber": "avec {{barberName}}",
    "upcomingAppointment": "À VENIR",
    "lastAppointment": "VOTRE DERNIER RENDEZ-VOUS",
    "welcomeMessage": "Salut {{name}}, il est temps de réserver votre prochain rendez-vous.",
    "analyzingBookings": "Nous analysons\nactivement vos\nréservations…",
    "notifyToBook": "Nous vous préviendrons\nquand il sera temps\nde réserver à nouveau",
    "noAppointmentData": "Aucune donnée de rendez-vous disponible",
    "noAppointmentDataSubtitle": "Veuillez réessayer de rechercher votre rendez-vous.",
    "moreUpcomingAppointments_one": "{{count}} AUTRE RENDEZ-VOUS À VENIR",
    "moreUpcomingAppointments_other": "{{count}} AUTRES RENDEZ-VOUS À VENIR",
    "accessibility": {
      "appointmentHomeScreen": "Écran d'accueil des rendez-vous",
      "signInButton": "Se connecter à votre compte",
      "signInButtonHint": "Accéder à toutes les fonctionnalités de votre compte",
      "viewMoreButton": "Voir plus de détails sur le rendez-vous",
      "viewMoreButtonHint": "Voir des informations supplémentaires sur ce rendez-vous",
      "bookAgainButton": "Réserver à nouveau dans ce salon",
      "bookAgainButtonHint": "Planifier un autre rendez-vous dans le même salon",
      "bookingAgain": "Nouvelle réservation en cours",
      "bookNewButton": "Réserver un nouveau rendez-vous",
      "bookNewButtonHint": "Planifier un nouveau rendez-vous",
      "appointmentCard": "Carte de détails du rendez-vous",
      "appointmentCardHint": "Affiche les informations de votre rendez-vous"
    }
  },
  "AppointmentSignInScreen": {
    "title": "Se connecter",
    "subtitle": "Connectez-vous à votre compte avec votre numéro de téléphone ou email.",
    "subtitlePhoneOnly": "Connectez-vous à votre compte avec votre numéro de téléphone.",
    "subtitleEmailOnly": "Connectez-vous à votre compte avec votre email.",
    "continueWith": "Continuer avec {{contact}} →",
    "verificationMessage": "Nous vous enverrons un code de vérification.",
    "supportMessage": "Vous ne reconnaissez pas le numéro de téléphone ou l'email. Veuillez contacter votre salon ou support@getsquire.com.",
    "useDifferentAccount": "Utiliser un compte différent",
    "close": "Fermer",
    "noContactMethods": "Aucune méthode de contact disponible",
    "accessibility": {
      "appointmentSignInScreen": "Écran de connexion au rendez-vous",
      "closeButton": "Fermer l'écran de connexion",
      "closeButtonHint": "Retourner aux détails du rendez-vous",
      "phoneSignInButton": "Se connecter avec le numéro de téléphone {{phone}}",
      "phoneSignInButtonHint": "Se connecter avec votre numéro de téléphone enregistré",
      "emailSignInButton": "Se connecter avec l'email {{email}}",
      "emailSignInButtonHint": "Se connecter avec votre adresse email enregistrée",
      "supportText": "Informations de contact du support",
      "useDifferentAccountButton": "Utiliser un compte différent"
    }
  },
  "AppointmentLookupCompleteProfileBottomSheet": {
    "title": "Informations\nrequises",
    "subtitle": "Pour votre sécurité, veuillez compléter votre profil ci-dessous",
    "firstNameLabel": "PRÉNOM",
    "lastNameLabel": "NOM",
    "phoneLabel": "TÉLÉPHONE",
    "emailLabel": "EMAIL",
    "firstNamePlaceholder": "Prénom",
    "lastNamePlaceholder": "Nom",
    "emailPlaceholder": "Email",
    "confirmButton": "Confirmer",
    "footerText": "L'email et le numéro de téléphone que vous fournissez seront utilisés pour les notifications de rendez-vous.",
    "accessibility": {
      "closeButton": "Fermer le formulaire de profil complet",
      "firstNameInput": "Champ de saisie du prénom",
      "lastNameInput": "Champ de saisie du nom",
      "phoneInput": "Champ de saisie du numéro de téléphone",
      "emailInput": "Champ de saisie de l'adresse email",
      "confirmButton": "Confirmer et soumettre les informations du profil",
      "closeButtonHint": "Ferme ce formulaire"
    },
    "validation": {
      "firstNameRequired": "Le prénom est requis",
      "firstNameInvalid": "Le prénom ne peut pas contenir de chiffres",
      "lastNameRequired": "Le nom est requis",
      "lastNameInvalid": "Le nom ne peut pas contenir de chiffres",
      "phoneRequired": "Le numéro de téléphone est requis",
      "emailRequired": "L'adresse email est requise",
      "phoneInvalid": "Veuillez entrer un numéro de téléphone valide",
      "emailInvalid": "Veuillez entrer une adresse email valide"
    }
  },
  "AppointmentsScreen": {
    "title": "Rendez-vous",
    "upcoming": "À VENIR",
    "past": "PASSÉS",
    "at": "à",
    "barberAtShop": "{{firstName}} {{lastInitial}}. chez {{shopName}}",
    "cancelled": "Annulé",
    "noAppointments": "Il n'y a pas encore de rendez-vous",
    "error": "Échec du chargement des rendez-vous. Veuillez réessayer.",
    "tryAgain": "Réessayer",
    "groupAppointmentCount": "{{count}} rendez-vous chez {{shop}}",
    "groupInitials": "G",
    "accessibility": {
      "closeButton": "Fermer l'écran des rendez-vous",
      "closeButtonHint": "Retourner à l'écran précédent",
      "appointmentItem": "Rendez-vous le {{date}} avec {{barber}} chez {{shop}}",
      "groupAppointmentItem": "{{count}} rendez-vous chez {{shop}}"
    },
    "barberDetailsFormat": "{{firstName}} {{lastNameInitial}}. chez {{shopName}}"
  },
  "AppointmentItem": {
    "cancelled": "Annulé",
    "accessibility": {
      "appointmentItem": "Élément de rendez-vous",
      "groupAppointmentItem": "Élément de rendez-vous de groupe"
    }
  },
  "availability": {
    "available": "Disponible\n{{date}}",
    "today": "Aujourd'hui",
    "tomorrow": "Demain",
    "anyProfessional": "Réserver avec n'importe\nquel professionnel"
  },
  "ChooseProfessionalScreen": {
    "title": "Choisir un professionnel",
    "accessibility": {
      "closeButton": "Fermer",
      "closeButtonHint": "Retourner à l'écran précédent"
    }
  },
  "ProfessionalGrid": {
    "anyProfessional": "Choisir d'abord un service",
    "availableToday": "Disponible aujourd'hui",
    "error": {
      "title": "Quelque chose s'est mal passé",
      "message": "Nous n'avons pas pu charger les professionnels disponibles. Veuillez réessayer plus tard.",
      "goHome": "Retour à l'accueil"
    },
    "empty": {
      "title": "Aucun professionnel disponible",
      "message": "Il n'y a actuellement aucun coiffeur disponible dans cet établissement"
    }
  },
  "GiftCard": {
    "title": "Acheter une carte cadeau",
    "subtitle": "Offrez le soin personnel"
  },
  "GiftCardAmountScreen": {
    "title": "Acheter une carte cadeau",
    "pleaseSelectAmount": "Veuillez sélectionner le montant",
    "previewTitle": "Carte cadeau",
    "previewSubtitle": "Offrez le cadeau du soin et de la mise en beauté",
    "previewAccessibilityLabelUnselected": "{{title}}. {{subtitle}}",
    "previewAccessibilityLabelSelected": "{{title}}. {{amount}}",
    "custom": "Personnalisé",
    "viewOrder": "Voir la commande",
    "summary": {
      "label": "Montant sélectionné",
      "placeholder": "Aucun montant sélectionné"
    },
    "customAmount": {
      "placeholder": "Entrez le montant"
    },
    "processing": "Traitement en cours",
    "tryAgain": "Réessayer"
  },
  "GiftCardOrderBar": {
    "viewOrder": "Voir la Commande",
    "continueButton": "Continuer",
    "accessibility": {
      "expandHint": "Ouvre le résumé de la commande",
      "orderSummary": "Carte cadeau {{amount}}. Appuyez pour voir la commande."
    }
  },
  "GiftCardOrderBottomSheet": {
    "title": "Votre Commande",
    "giftCardItem": "Carte Cadeau",
    "subtotal": "Sous-total",
    "continueButton": "Continuer",
    "anyProfessional": "N'importe quel professionnel",
    "accessibility": {
      "closeBottomSheet": "Fermer le résumé de la commande",
      "closeBottomSheetHint": "Ferme le récapitulatif de la commande"
    }
  },
  "ConfirmGiftCardBottomSheet": {
    "title": "Acheter une carte cadeau",
    "haveAccount": "Vous avez un compte ?",
    "signIn": "Se connecter",
    "buyGiftCard": "Acheter une carte cadeau",
    "buyingGiftCard": "Achat de la carte cadeau",
    "paymentMethod": "Mode de Paiement",
    "creditOrDebitCard": "Carte ou compte bancaire",
    "applePay": "Apple Pay",
    "googlePay": "Google Pay",
    "giftCardSummary": "Carte Cadeau",
    "legalText": "En continuant, vous acceptez nos",
    "termsOfService": "Conditions d'Utilisation",
    "and": "et",
    "privacyPolicy": "Politique de Confidentialité",
    "accessibility": {
      "bookButton": "Acheter la carte cadeau",
      "bookButtonHint": "Finalise votre achat de carte cadeau",
      "paymentMethod": "Mode de paiement : {{method}}",
      "paymentMethodHint": "Sélectionner {{method}} comme paiement"
    },
    "userInformation": {
      "title": "Vos Informations",
      "firstNamePlaceholder": "Prénom",
      "lastNamePlaceholder": "Nom de famille",
      "phonePlaceholder": "Numéro de téléphone",
      "emailPlaceholder": "E-mail",
      "accessibility": {
        "firstNameInput": "Prénom",
        "lastNameInput": "Nom de famille",
        "phoneInput": "Numéro de téléphone",
        "phoneInputHint": "Entrez votre numéro de téléphone",
        "emailInput": "Adresse e-mail"
      },
      "validation": {
        "firstNameRequired": "Le prénom est requis",
        "firstNameInvalid": "Le prénom ne doit contenir que des lettres",
        "lastNameRequired": "Le nom de famille est requis",
        "lastNameInvalid": "Le nom de famille ne doit contenir que des lettres",
        "phoneInvalid": "Veuillez entrer un numéro de téléphone valide",
        "emailInvalid": "Veuillez entrer une adresse e-mail valide",
        "emailRequired": "L'adresse e-mail est requise",
        "paymentMethodRequired": "Veuillez sélectionner un mode de paiement"
      }
    },
    "error": {
      "purchaseFailed": "Une erreur est survenue. Veuillez réessayer.",
      "paymentError": "Le paiement a échoué. Veuillez réessayer."
    }
  },
  "ViewGiftCardScreen": {
    "title": "Gift Card",
    "thankYouTitle": "Merci d'avoir acheté votre carte cadeau",
    "promotionalHeadline": "Offrez le cadeau du soin",
    "promotionalDescription": "Tout le monde aime avoir une belle allure : offrez-vous ce cadeau !",
    "giftCardForShop": "Cette carte cadeau est pour {{shopName}}",
    "code": "Code de carte cadeau",
    "totalPrice": "Prix total",
    "anyProfessional": "N'importe quel professionnel",
    "giftCardItem": "Carte Cadeau",
    "done": "Terminé",
    "copiedToClipboard": "Code copié dans le presse-papiers",
    "paymentDetails": "Détails du paiement",
    "close": "Fermer",
    "accessibility": {
      "closeHint": "Ferme la carte cadeau"
    }
  },
  "ProfessionalCard": {
    "anyProfessional": "Choisir d'abord un service",
    "bookWithAnyProfessional": "Réserver avec n'importe quel professionnel",
    "professionalFallback": "Professionnel",
    "giftCard": {
      "title": "Acheter une carte cadeau",
      "subtitle": "Offrez le cadeau du soin",
      "accessibility": {
        "label": "Acheter une carte cadeau",
        "hint": "Ouvre l'achat d'une carte cadeau"
      }
    },
    "availability": {
      "available": "Disponible {{date}}",
      "today": "Aujourd'hui",
      "tomorrow": "Demain",
      "notAvailable": "Non Disponible"
    },
    "infoIcon": {
      "accessibility": {
        "label": "Voir les informations du professionnel",
        "hint": "Ouvre les détails et les photos Instagram"
      }
    },
    "accessibility": {
      "selectAnyProfessional": "Sélectionner n'importe quel professionnel pour votre rendez-vous",
      "selectProfessional": "Sélectionner {{name}} comme votre professionnel",
      "selectThisProfessional": "Sélectionner ce professionnel",
      "currentlySelected": "Actuellement sélectionné. Appuyez pour désélectionner.",
      "tapToSelect": "Appuyez pour sélectionner ce professionnel pour votre rendez-vous."
    }
  },
  "ProfessionalPasscodeBottomSheet": {
    "title": "Entrer le code",
    "subtitle": "Ce professionnel requiert un code pour réserver",
    "unlocked": "Débloqué",
    "verifying": "Vérification...",
    "placeholder": "Entrer le code",
    "submit": "Débloquer",
    "cancel": "Annuler",
    "error": {
      "invalid": "Code invalide. Veuillez réessayer.",
      "incorrectPassword": "Code incorrect",
      "network": "Erreur réseau. Veuillez réessayer."
    },
    "accessibility": {
      "input": "Champ de saisie du code",
      "submit": "Envoyer le code pour débloquer la réservation",
      "cancel": "Annuler la saisie du code et retourner"
    }
  },
  "ProfessionalInfoBottomSheet": {
    "title": "{{name}}",
    "viewOnInstagram": "Voir plus sur Instagram",
    "accessibility": {
      "close": "Fermer les informations du professionnel",
      "instagramImage": "Photo Instagram {{index}} sur {{total}}",
      "closeHint": "Ferme les détails du professionnel"
    }
  },
  "ProfessionalInstagramGallery": {
    "counter": "{{current}} / {{total}}",
    "accessibility": {
      "back": "Retour à la grille de photos",
      "image": "Photo Instagram {{index}}",
      "thumbnail": "Voir la photo Instagram {{index}}"
    }
  },
  "ChooseServiceCategoryScreen": {
    "title": "Choisir un service",
    "empty": {
      "message": "Aucun service n'est disponible à la réservation pour le moment"
    }
  },
  "ChooseServiceSubcategoryScreen": {
    "title": "Choisir un service",
    "empty": {
      "message": "Aucun service n'est disponible à la réservation pour le moment"
    }
  },
  "CategoryUnavailable": {
    "title": "Cette catégorie n'est pas disponible",
    "description": "Nous n'avons trouvé aucun service ici pour le moment. Essayez une autre option.",
    "backToCategories": "Retour aux catégories",
    "backToSubcategories": "Retour aux sous-catégories"
  },
  "ChooseServiceScreen": {
    "title": "Choisir un service",
    "categoryHeading": "Services de {{name}}",
    "ok": "OK",
    "cartCreationFailed": "Échec de la création du panier",
    "cartCreationError": "Impossible de créer le panier : {{message}}. Veuillez réessayer.",
    "loading": {
      "servicesText": "Chargement des services...",
      "findingServicesFor": "Recherche de services pour",
      "anyProfessional": "n'importe quel professionnel"
    },
    "error": {
      "title": "Impossible de charger les services",
      "message": "Un problème est survenu lors du chargement des services. Veuillez réessayer plus tard.",
      "tryAgain": "Réessayer"
    },
    "accessibility": {
      "closeButton": "Fermer la sélection de service",
      "closeButtonHint": "Ferme l'écran de sélection de service et retourne à l'écran précédent"
    }
  },
  "CategorySelect": {
    "placeholder": "Sélectionner une catégorie",
    "all": "Tous",
    "uncategorized": "Sans catégorie"
  },
  "ServiceCategoryBreadcrumb": {
    "anyProfessional": "Peu importe"
  },
  "ServiceCategoryRow": {
    "servicesCount_one": "{{count}} service",
    "servicesCount_other": "{{count}} services"
  },
  "ServiceGrid": {
    "additionalServicesTitle": "Quelque chose que vous souhaitez ajouter ?",
    "yourServicesTitle": "Vos services",
    "yourAddonsTitle": "Vos compléments",
    "otherServicesTitle": "Autres services",
    "error": {
      "title": "Impossible de charger les services",
      "message": "Un problème est survenu lors du chargement des services. Veuillez réessayer plus tard."
    },
    "empty": {
      "filtered": {
        "title": "Aucun service dans cette catégorie",
        "message": "Essayez de sélectionner une autre catégorie ou \"Tous\" pour voir plus de services."
      },
      "unfiltered": {
        "title": "Aucun service disponible",
        "message": "Il n'y a actuellement aucun service disponible dans cet établissement."
      }
    },
    "categoryFilterPlaceholder": "Filtrer par catégorie",
    "addonCategoryLabel": "Compléments"
  },
  "ViewOrderBar": {
    "viewOrder": "Voir la commande",
    "goToCheckout": "Aller au paiement",
    "itemCount": {
      "one": "1 article",
      "other": "{{count}} articles"
    },
    "accessibility": {
      "expandHint": "Appuyez pour développer les détails de la commande",
      "orderSummary": "Résumé de la commande : {{itemCount}}, {{totalPrice}}"
    },
    "continue": "Continuer"
  },
  "ViewOrderCartPromo": {
    "saving": "Économie de {{amount}} avec la promotion",
    "useBy": "À utiliser avant le {{date}}"
  },
  "ViewOrderDepositCard": {
    "title": "Acompte à payer aujourd'hui",
    "refundable": "Réserve votre rendez-vous. Déduit de votre prestation et remboursable.",
    "nonRefundable": "Réserve votre rendez-vous. Déduit de votre prestation. Non remboursable."
  },
  "ViewOrderBottomSheet": {
    "depositDueToday": "Acompte à payer aujourd'hui",
    "title": "Votre commande",
    "shopNamePlaceholder": "Salon",
    "anyProfessional": "N'importe quel professionnel",
    "addGuest": "Ajouter un invité à la commande",
    "checkoutAllAtOnce": "Tout payer en une fois",
    "groupOrderLimitReached": "Limite de commande groupée atteinte",
    "groupOrderLimitDescription": "Vous pouvez ajouter jusqu'à 5 rendez-vous",
    "subtotal": "Sous-total",
    "chooseTime": "Choisir un horaire",
    "nextAvailableTime": "Prochain horaire disponible",
    "addButton": "Ajouter",
    "tip": "Pourboire",
    "tipTooltip": "Pourboire préliminaire pour votre professionnel.\nPeut être ajusté après le rendez-vous, reflétant votre expérience globale.",
    "tipTooltipGroup": "Pourboire préliminaire pour votre professionnel.\nLaisser un pourboire au même professionnel ne peut s'appliquer qu'une seule fois.",
    "guestAppointment": "Rendez-vous invité",
    "waitlistMeFor": "Liste d'attente pour {{date}}",
    "joinWaitlistFor": "Rejoindre la liste d'attente pour {{date}}",
    "preferredTime": "Horaire préféré",
    "accessibility": {
      "closeOrderSummary": "Fermer le résumé de la commande",
      "closeOrderSummaryHint": "Appuyez pour fermer le résumé de la commande",
      "addGuestButton": "Ajouter un invité au rendez-vous de groupe",
      "editOrder": "Modifier la commande"
    }
  },
  "EditOrderBottomSheet": {
    "title": "Modifier la commande",
    "done": "Terminé",
    "location": "Emplacement",
    "professional": "Professionnel",
    "services": "Services",
    "dateTime": "Date et heure",
    "anyProfessional": "N'importe quel professionnel",
    "guestAppointment": "Rendez-vous invité",
    "accessibility": {
      "editLocation": "Modifier l'emplacement",
      "editProfessional": "Modifier le professionnel",
      "editServices": "Modifier les services",
      "editTime": "Modifier la date et l'heure",
      "removeAddon": "Retirer {{name}}"
    }
  },
  "PriceRangeTooltip": {
    "content": "Les professionnels fixent leurs propres tarifs, cette fourchette correspond donc à l'ensemble de l'équipe. Choisissez un professionnel pour voir son tarif exact.",
    "accessibilityLabel": "Informations sur la fourchette de prix"
  },
  "ServiceCard": {
    "giftCard": {
      "title": "Carte cadeau",
      "fromPrice": "à partir de {{price}}",
      "accessibility": {
        "label": "Carte cadeau, {{fromPrice}}",
        "hint": "Ouvre l'achat d'une carte cadeau"
      }
    },
    "duration": {
      "minutes": "min",
      "hours": "h",
      "minutesShort": "m"
    },
    "action": {
      "addService": "Ajouter un service",
      "removeService": "Retirer le service"
    },
    "badge": {
      "addon": "Complément"
    },
    "description": {
      "moreDetails": "Plus de détails",
      "lessDetails": "Moins de détails"
    },
    "accessibility": {
      "serviceInformation": "Informations sur le service",
      "hideDescription": "Masquer la description du service",
      "showDescription": "Afficher la description du service",
      "serviceDetails": "Service : {{name}}, Durée : {{duration}}, Prix : {{price}}",
      "currentlySelected": "Service actuellement sélectionné",
      "tapToSelect": "Appuyez pour sélectionner ce service"
    }
  },
  "ChooseTimeGuestSection": {
    "anyProfessional": "N'importe quel professionnel",
    "noAvailableTimes": "Aucun horaire disponible",
    "noTimesAvailable": "Aucun horaire disponible",
    "oneTimeAvailable": "1 horaire disponible",
    "timesAvailable": "{{count}} horaires disponibles",
    "suggestedForYou": "Suggéré pour vous",
    "duration": {
      "hours": "h",
      "hoursPlural": "h",
      "minutes": "min"
    }
  },
  "ViewOrderBottomSheetActions": {
    "accessibility": {
      "chooseTimeButton": "Bouton choisir un horaire",
      "chooseTimeButtonHint": "Appuyez pour choisir un horaire",
      "nextAvailableTimeButton": "Bouton prochain horaire disponible",
      "nextAvailableTimeButtonHint": "Appuyez pour choisir le prochain horaire disponible",
      "continueButton": "Bouton continuer",
      "continueButtonHint": "Appuyez pour continuer"
    },
    "continue": "Continuer",
    "waitlistDisclaimer": "Une carte enregistrée est requise pour être placé sur la liste d'attente. Les frais ne s'appliquent que si vous acceptez une réservation."
  },
  "TimeSlotButton": {
    "accessibility": {
      "tapToSelect": "Appuyez pour sélectionner cet horaire",
      "notAvailable": "Cet horaire n'est pas disponible"
    }
  },
  "ChooseTimeSlotGrid": {
    "showAll": "Tout afficher",
    "showLess": "Afficher moins",
    "accessibility": {
      "showAllTimes": "Afficher tous les horaires",
      "showLessTimes": "Afficher moins d'horaires"
    }
  },
  "ChooseTimeCalendarDay": {
    "accessibility": {
      "notAvailable": "Non disponible",
      "noTimesAvailable": "Aucun horaire disponible",
      "oneTime": "1 horaire",
      "multipleTimes": "{{count}} horaires",
      "available": "disponibles",
      "tapToSelect": "Appuyez pour sélectionner cette date"
    }
  },
  "ChooseTimeEmptyState": {
    "nextTime": "Prochain horaire",
    "noAvailability": "Aucune disponibilité",
    "waitlist": "Liste d'attente"
  },
  "WaitlistTimePreferencePicker": {
    "title": "Quel horaire préférez-vous ?",
    "anytime": "N'importe quand",
    "morning": "Matin",
    "afternoon": "Après-midi",
    "evening": "Soir",
    "afterHours": "Hors des heures d'ouverture",
    "range": {
      "morning": "9h00 - 12h00",
      "afternoon": "12h00 - 17h00",
      "evening": "17h00 - 20h00",
      "afterHours": "à partir de 20h00"
    },
    "accessibility": {
      "anytime": "N'importe quand",
      "morning": "Matin, de 9h00 à 12h00",
      "afternoon": "Après-midi, de 12h00 à 17h00",
      "evening": "Soir, de 17h00 à 20h00",
      "afterHours": "Hors des heures d'ouverture, à partir de 20h00",
      "rowHint": "Ajoutez ou retirez cet horaire de votre préférence sur la liste d'attente",
      "anytimeHint": "Retirez les autres horaires pour accepter n'importe quelle heure"
    }
  },
  "StandbyWaitlistJoinSheet": {
    "title": "Rejoindre la liste d'attente",
    "cta": "Inscrivez-moi sur la liste d'attente",
    "legalIntro": "En rejoignant la liste d'attente, vous acceptez les",
    "summary": {
      "title": "Récapitulatif",
      "joinWaitlistFor": "Rejoindre la liste d'attente pour",
      "preferredTime": "Horaire préféré",
      "professional": "Professionnel",
      "anyProfessional": "N'importe quel professionnel",
      "duration": "Durée",
      "total": "Total"
    },
    "accessibility": {
      "ctaHint": "Vous inscrit sur la liste d'attente pour ce jour"
    }
  },
  "ChooseTimeLoadingScreen": {
    "title": "Choisir un horaire"
  },
  "ChooseTimeScreen": {
    "title": "Choisir un horaire",
    "processing": "Traitement",
    "ok": "OK",
    "preselectDateOutsideWindow": "Cette date est en dehors de la fenêtre de réservation en ligne, nous n'avons donc pas pu la sélectionner pour vous",
    "error": {
      "title": "Erreur",
      "paymentError": "Un problème est survenu avec le paiement",
      "bookingPaymentError": "Une erreur s'est produite lors du traitement du paiement de la réservation. Veuillez réessayer.",
      "alreadyOnWaitlist": "Vous êtes déjà sur la liste d'attente",
      "throttled": "Trop de tentatives. Patientez un instant et réessayez.",
      "standbyWaitlistUnavailable": "Cette liste d'attente n'est pas disponible pour le moment.",
      "standbyAlreadyOnWaitlist": "Vous êtes déjà sur la liste d'attente",
      "paymentRequiredForWaitlist": "Un mode de paiement est requis pour rejoindre cette liste d'attente",
      "digitalWalletNotAvailable": "Le mode de paiement par portefeuille numérique n'est pas disponible",
      "digitalWalletPaymentFailed": "Le paiement a échoué",
      "digitalWalletUnexpectedError": "Une erreur inattendue s'est produite",
      "cartExpired": "Votre session de réservation a expiré. Veuillez recommencer votre réservation.",
      "startOver": "Recommencer",
      "timeoutTitle": "Délai d'attente dépassé",
      "timeoutMessage": "Votre réservation a peut-être été effectuée. Veuillez vérifier vos prochains rendez-vous avant de réessayer.",
      "networkTitle": "Connexion perdue",
      "networkMessage": "Veuillez vérifier votre connexion internet et réessayer.",
      "paymentFailedTitle": "Échec du paiement",
      "paymentFailedMessage": "Votre paiement n'a pas pu être traité. Veuillez essayer un autre moyen de paiement.",
      "serverErrorTitle": "Une erreur s'est produite",
      "serverErrorMessage": "Une erreur inattendue s'est produite. Veuillez réessayer plus tard.",
      "deepLinkUnavailableTitle": "Non disponible",
      "deepLinkUnavailableMessage": "Ce service n'est pas disponible pour une réservation en ligne pour le moment.",
      "goBack": "Retour"
    }
  },
  "Calendar": {
    "today": "Aujourd'hui",
    "accessibility": {
      "previousMonth": "Mois précédent",
      "nextMonth": "Mois suivant"
    }
  },
  "CalendarDay": {
    "accessibility": {
      "today": "Aujourd'hui",
      "selected": "Sélectionné",
      "notAvailable": "Non disponible",
      "tapToSelect": "Appuyez pour sélectionner cette date"
    }
  },
  "TipSelector": {
    "none": "Aucun",
    "other": "Autre",
    "dollarSign": "€",
    "accessibility": {
      "enterCustomTip": "Entrez le montant du pourboire personnalisé en euros",
      "enterCustomTipHint": "Entrez un montant de pourboire personnalisé. Valeur actuelle : {{value}}",
      "dollarSign": "Symbole euro",
      "confirmButton": "Confirmer le montant du pourboire{{amount}}",
      "confirmButtonHint": "{{hasAmount}}",
      "confirmButtonHintWithAmount": "Confirmer le montant du pourboire de {{amount}}€",
      "confirmButtonHintEmpty": "Entrez d'abord un montant de pourboire, puis confirmez",
      "confirm": "Confirmer",
      "tipSelectionOptions": "Options de sélection du pourboire",
      "tipSelectionHint": "Sélectionnez un montant de pourboire pour votre service",
      "noTip": "Aucun pourboire",
      "noTipHint": "Sélectionnez pour ne pas donner de pourboire",
      "percentageTip": "{{percentage}}% de pourboire",
      "percentageTipHint": "Sélectionnez {{percentage}}% de pourboire pour un montant de {{amount}}€",
      "customTip": "Pourboire personnalisé de {{amount}}€",
      "customTipAmount": "Montant du pourboire personnalisé",
      "customTipSelected": "Montant du pourboire personnalisé actuellement sélectionné",
      "customTipSelect": "Sélectionnez pour entrer un montant de pourboire personnalisé"
    },
    "custom": "Personnalisé"
  },
  "AdultOnlyConsent": {
    "title": "21 ans et plus",
    "ageRestriction": "21+",
    "descriptionPrefix": "En réservant un rendez-vous, vous acceptez que",
    "descriptionSuffix": "vous avez 21 ans ou plus.",
    "agree": "J'accepte"
  },
  "CancellationPolicy": {
    "title": "Politique d'annulation",
    "cannotCancelDescription": "Selon la politique d'annulation, vous ne pouvez pas annuler ce rendez-vous.",
    "cannotCancelDescriptionGiftCard": "Selon la politique d'annulation, vous ne pouvez pas annuler cette commande.",
    "freeCancellation": "Annulation gratuite jusqu'à {{time}} le {{date}}"
  },
  "CancellationPolicyConsent": {
    "title": "Politique d'annulation",
    "description": "Vous aurez jusqu'à <strong>{{time}}</strong> le <strong>{{date}}</strong> pour annuler ce rendez-vous sans être facturé.",
    "now": "MAINTENANT",
    "understand": "J'accepte"
  },
  "NotificationConsent": {
    "accessibility": {
      "sms": {
        "yes": "Oui, recevoir des messages texte promotionnels",
        "skip": "Ignorer, ne pas recevoir de messages texte"
      },
      "email": {
        "yes": "Oui, recevoir des e-mails promotionnels",
        "skip": "Ignorer, ne pas recevoir d'e-mails"
      }
    },
    "title": "{{name}} souhaite rester en contact !",
    "yes": "Oui",
    "skip": "Ignorer",
    "sms": {
      "description": "En cliquant sur \"Oui\" ci-dessous, vous acceptez de recevoir des messages texte promotionnels automatisés au numéro de mobile que vous fournirez.",
      "descriptionTerms": "Le consentement n'est pas une condition d'achat. Envoyez HELP pour obtenir de l'aide et STOP pour annuler. Des frais de message et de données peuvent s'appliquer et le tarif des messages varie. Tous les opérateurs ne sont pas couverts. Consultez les <modalLink>Conditions et confidentialité</modalLink> pour plus d'informations."
    },
    "email": {
      "description": "En cliquant sur \"Oui\" ci-dessous, vous acceptez de recevoir des e-mails promotionnels à l'adresse e-mail que vous fournirez.",
      "descriptionTerms": "Le consentement n'est pas une condition d'achat. Vous pouvez vous désabonner à tout moment en utilisant le lien dans n'importe quel e-mail. Consultez les <modalLink>Conditions et confidentialité</modalLink> pour plus d'informations."
    }
  },
  "AppStoreReviewPrompt": {
    "title": "Que pensez-vous de l'application jusqu'à présent ?",
    "description": "Que vous nous adoriez ou que vous ayez des commentaires, nous voulons le savoir !",
    "primaryButton": "J'adore !",
    "secondaryButton": "À améliorer",
    "accessibility": {
      "closeButton": "Fermer l'invite d'avis",
      "closeButtonHint": "Ferme cette invite d'avis"
    }
  },
  "NPSSurveyModal": {
    "title": "Question rapide",
    "question": "Quelle est la probabilité que vous recommandiez SQUIRE à vos amis et collègues ?",
    "fromNotLikely": "De peu probable",
    "toMostLikely": "à très probable",
    "maybeLater": "Peut-être plus tard",
    "done": "Terminé",
    "sendFeedback": "Envoyer le commentaire",
    "thankYouTitle": "Merci !",
    "anythingElse": "Autre chose à ajouter ?",
    "thankYouBody": "Vos commentaires seront utilisés pour améliorer nos services",
    "reasonLabel": "RAISON DE VOTRE SCORE",
    "reasonPlaceholder": "Entrez vos commentaires",
    "thankYouToast": "Merci pour votre temps !",
    "submitError": "Échec de l'envoi. Veuillez réessayer."
  },
  "TermsWebViewModal": {
    "title": "Conditions d'utilisation",
    "accessibility": {
      "closeButton": "Fermer les conditions",
      "closeButtonHint": "Ferme les conditions générales"
    }
  },
  "TermsScreen": {
    "title": "Conditions d'utilisation",
    "loading": "Chargement des conditions...",
    "error": "Échec du chargement des conditions d'utilisation"
  },
  "WebViewScreen": {
    "errorTitle": "Échec du chargement du contenu",
    "errorMessage": "Veuillez vérifier votre connexion Internet et réessayer.",
    "accessibility": {
      "loadingContent": "Chargement du contenu",
      "closeButton": "Fermer",
      "closeButtonHint": "Ferme l'écran et retourne à la page précédente"
    }
  },
  "PrivacyScreen": {
    "title": "Politique de confidentialité",
    "loading": "Chargement de la politique de confidentialité...",
    "error": "Échec du chargement de la politique de confidentialité"
  },
  "ProfileScreen": {
    "editProfile": "Modifier le profil",
    "phoneNotProvided": "Numéro de téléphone non défini",
    "editPhoneNumber": "Modifier le numéro de téléphone",
    "setPhoneNumber": "Définir le numéro de téléphone",
    "editEmail": "Modifier l'email",
    "changePassword": "Changer le mot de passe",
    "notifications": "Notifications",
    "confirm": "Confirmer",
    "reschedule": "Reprogrammer",
    "cancel": "Annuler",
    "deleteAccount": "Supprimer le compte",
    "firstName": "Prénom",
    "lastName": "Nom",
    "saveChanges": "Enregistrer",
    "editFirstName": "Appuyez pour modifier le prénom",
    "editLastName": "Appuyez pour modifier le nom",
    "nameSaved": "Nom mis à jour avec succès",
    "nameUpdateFailed": "Échec de la mise à jour du nom",
    "error": "Impossible de charger le profil",
    "tryAgain": "Réessayer",
    "accessibility": {
      "closeButton": "Fermer l'écran de profil",
      "closeButtonHint": "Retourner à l'écran précédent",
      "profileInfo": "Section d'informations de profil",
      "editPhoto": "Modifier la photo de profil",
      "editPhoneNumberButton": "Modifier le numéro de téléphone",
      "setPhoneNumberButton": "Définir le numéro de téléphone",
      "editEmailButton": "Modifier l'email",
      "changePasswordButton": "Changer le mot de passe",
      "notificationsButton": "Paramètres de notifications",
      "deleteAccountButton": "Supprimer le compte",
      "deleteAccountButtonHint": "Supprimer définitivement votre compte",
      "firstNameEdit": "Modifier le prénom",
      "lastNameEdit": "Modifier le nom",
      "saveNameButton": "Enregistrer les modifications du nom",
      "saveChanges": "Enregistrer les modifications",
      "saveChangesHint": "Enregistrer le nom modifié",
      "photoGalleryConfirm": "Utiliser la photo sélectionnée",
      "photoGalleryClose": "Fermer la galerie de photos"
    },
    "editPhoto": {
      "empty": "Aucune photo trouvée",
      "uploadError": {
        "title": "Impossible de mettre à jour la photo",
        "message": "Une erreur s'est produite lors du téléchargement de votre photo. Veuillez réessayer."
      }
    }
  },
  "AppointmentDetailMap": {
    "accessibility": {
      "closeButton": "Fermer les détails du rendez-vous"
    }
  },
  "AppointmentDetailShopInfo": {
    "appointmentCancelled": "Rendez-vous annulé",
    "getDirections": "Obtenir l'itinéraire",
    "accessibility": {
      "getDirections": "Obtenir l'itinéraire vers le salon"
    }
  },
  "AppointmentDetailInfo": {
    "cancelled": "Annulé",
    "confirmationCode": "Code de confirmation",
    "professional": "Professionnel",
    "professionalNoLongerAvailable": "N'est plus disponible",
    "service": "Service",
    "time": "Heure",
    "tip": "Pourboire",
    "addTip": "Ajouter un pourboire",
    "addToCalendar": "Ajouter au calendrier",
    "rateYourAppointment": "Notez votre rendez-vous",
    "youRatedStars": "Vous avez donné {{count}} étoiles",
    "calendarTitle": {
      "withShop": "{{serviceName}} chez {{shopName}}",
      "withProfessional": "{{serviceName}} avec {{professionalName}}"
    },
    "calendarDescription": {
      "confirmationCode": "Code de confirmation : {{confirmationCode}}",
      "professional": "Professionnel : {{professionalName}}",
      "service": "Service : {{serviceName}}",
      "location": "Lieu : {{shopName}}"
    },
    "accessibility": {
      "addToCalendar": "Ajouter le rendez-vous au calendrier",
      "addTip": "Ajouter un pourboire pour ce rendez-vous",
      "changeTip": "Modifier le montant du pourboire",
      "rateAppointmentButton": "Notez votre rendez-vous",
      "rateAppointmentButtonHint": "Appuyez pour noter ce rendez-vous",
      "ratingDisplay": "Vous avez noté ce rendez-vous {{count}} étoiles",
      "starIcon": "Étoile {{position}} sur {{total}}"
    }
  },
  "AppointmentRatingPromptModal": {
    "successMessage": "Merci pour vos commentaires !",
    "loadError": "Échec du chargement des données du rendez-vous. Veuillez réessayer.",
    "accessibility": {
      "closeButton": "Fermer l'invite de notation",
      "closeButtonHint": "Ferme cette invite de notation"
    }
  },
  "AppointmentRatingScreen": {
    "title": "Notez votre rendez-vous",
    "successMessage": "Merci pour vos commentaires !",
    "error": "Échec du chargement des données du rendez-vous. Veuillez réessayer.",
    "tryAgain": "Réessayer",
    "step1": {
      "heading": "Comment s'est passée votre expérience avec {{firstName}} ?",
      "nextButton": "Suivant"
    },
    "step2": {
      "heading": "Merci pour votre note ! Quelque chose d'autre que vous souhaitez partager ?",
      "inputPlaceholder": "Partagez des détails sur les compétences, la ponctualité, etc.",
      "skipButton": "Ignorer",
      "submitButton": "Soumettre l'avis"
    },
    "accessibility": {
      "closeButton": "Fermer l'écran de notation",
      "closeButtonHint": "Annuler et retourner aux détails du rendez-vous",
      "nextButton": "Continuer à l'étape d'avis",
      "nextButtonHint": "Procéder à l'ajout d'un avis optionnel",
      "skipButton": "Ignorer l'avis et soumettre la note",
      "skipButtonHint": "Soumettre la note sans avis",
      "submitButton": "Soumettre la note avec l'avis",
      "submitButtonHint": "Soumettre votre note de {{count}} étoiles et votre avis",
      "starButton": "Noter {{count}} étoiles",
      "starButtonHint": "Sélectionner une note de {{count}} étoiles"
    }
  },
  "AppointmentDetailSummary": {
    "subtotal": "Sous-total",
    "services": "Services",
    "taxesAndFees": "Taxes et frais",
    "tax": "Taxe",
    "fee": "Frais",
    "tip": "Pourboire",
    "total": "Total",
    "addTip": "Ajouter un pourboire",
    "changeTip": "Modifier",
    "addCode": "Ajouter un code",
    "promo": "Promo",
    "membership": "Abonnement",
    "giftCard": "Carte cadeau",
    "accessibility": {
      "addTip": "Ajouter un pourboire à votre rendez-vous",
      "changeTip": "Modifier le montant du pourboire",
      "addCode": "Ajouter un code promo",
      "removePromo": "Supprimer le code promo",
      "expandTaxes": "Développer le détail des taxes et frais",
      "collapseTaxes": "Réduire le détail des taxes et frais"
    }
  },
  "AppointmentDetailPayment": {
    "chargeDisclaimer": "Vous ne serez pas facturé avant une heure avant le début de votre rendez-vous."
  },
  "AppointmentDetailActions": {
    "reschedule": "Reprogrammer",
    "cancel": "Annuler",
    "rebook": "Réserver à nouveau",
    "rebooking": "Réservation en cours...",
    "rebookError": "Impossible de réserver à nouveau le rendez-vous",
    "rebookErrorDescription": "Cette commande ne peut pas être réservée à nouveau pour le moment.",
    "barberUnavailable": "Votre barbier n'est plus disponible. Choisissez-en un nouveau.",
    "serviceUnavailable": "Le service réservé n'est plus disponible. Choisissez-en un nouveau.",
    "accessibility": {
      "reschedule": "Reprogrammer le rendez-vous",
      "cancel": "Annuler le rendez-vous",
      "rebook": "Réserver à nouveau le rendez-vous",
      "rebooking": "Réservation en cours..."
    }
  },
  "TipSelectionModal": {
    "title": "Modifier le pourboire",
    "none": "Aucun",
    "other": "Autre",
    "confirm": "Confirmer",
    "dollarSign": "€",
    "accessibility": {
      "close": "Fermer la fenêtre de sélection du pourboire",
      "tipPercentage": "{{percentage}}% de pourboire",
      "noTip": "Aucun pourboire",
      "customTip": "Montant du pourboire personnalisé",
      "confirm": "Confirmer la sélection du pourboire",
      "dollarSign": "Symbole euro",
      "enterCustomTipHint": "Entrez un montant de pourboire personnalisé. Valeur actuelle : {{value}}",
      "confirmCustomTip": "Confirmer le montant du pourboire personnalisé",
      "closeHint": "Ferme cette boîte de dialogue"
    }
  },
  "CalendarSelectionModal": {
    "title": "Ajouter au calendrier",
    "googleCalendar": "Google Calendar",
    "appleCalendar": "Apple iCalendar",
    "accessibility": {
      "close": "Fermer la fenêtre de sélection du calendrier",
      "googleCalendar": "Ajouter le rendez-vous à Google Calendar",
      "appleCalendar": "Ajouter le rendez-vous à Apple Calendar",
      "closeHint": "Ferme cette boîte de dialogue"
    }
  },
  "PromoCodeModal": {
    "title": "Ajouter un code",
    "codeLabel": "CODE",
    "codePlaceholder": "Entrez votre code",
    "apply": "Appliquer",
    "accessibility": {
      "close": "Fermer la fenêtre de code promo",
      "codeInput": "Saisie du code promo",
      "codeInputHint": "Entrez votre code promo",
      "apply": "Appliquer le code promo"
    }
  },
  "AppointmentDetailScreen": {
    "title": "Détails du rendez-vous",
    "orderInfo": "Informations de commande",
    "professionalNoLongerAvailable": "N'est plus disponible",
    "error": "Échec du chargement des détails du rendez-vous. Veuillez réessayer.",
    "tryAgain": "Réessayer",
    "accessibility": {
      "closeButton": "Fermer les détails du rendez-vous",
      "closeButtonHint": "Retourner à la liste des rendez-vous"
    }
  },
  "ViewReservationContentWrapper": {
    "confirmation": {
      "title": "{{name}}, votre rendez-vous est confirmé.",
      "titleGeneric": "Votre rendez-vous est confirmé.",
      "orderTitle": "{{name}}, votre commande est confirmée.",
      "orderTitleGeneric": "Votre commande est confirmée."
    },
    "canceled": {
      "title": "Rendez-vous annulé",
      "orderTitle": "Commande annulée"
    },
    "totalPrice": "Prix total",
    "taxes": "Taxes",
    "fee": "Frais",
    "giftCard": "Carte cadeau",
    "promo": "Promo",
    "membership": "Abonnement",
    "addToCalendar": "Ajouter au calendrier",
    "appleCalendar": "iCalendar",
    "googleCalendar": "Google",
    "yahooCalendar": "Yahoo",
    "actions": {
      "reschedule": "Reprogrammer le rendez-vous",
      "cancel": "Annuler le rendez-vous",
      "scheduleAnother": "Planifier un autre rendez-vous"
    },
    "accessibility": {
      "close": "Fermer",
      "appleCalendar": "Ajouter à Apple Calendar",
      "googleCalendar": "Ajouter à Google Calendar",
      "yahooCalendar": "Ajouter à Yahoo Calendar",
      "closeHint": "Ferme les détails de la réservation"
    }
  },
  "ViewReservationAppointmentCard": {
    "confirmationCode": "Code de confirmation",
    "duration": {
      "label": "Durée",
      "hours": "h",
      "minutes": "min",
      "minutesShort": "m"
    },
    "time": "Heure",
    "tip": "Pourboire",
    "accessibility": {
      "rescheduleAppointment": "Reprogrammer le rendez-vous"
    }
  },
  "ViewReservationPaymentStatus": {
    "pay": "Payer",
    "applePay": "Apple Pay",
    "creditCard": "Carte de crédit",
    "giftCard": "Carte cadeau",
    "payInPerson": "Payer sur place",
    "pending": "PAIEMENT EN ATTENTE",
    "canceled": "ANNULÉ",
    "paid": "PAYÉ",
    "disclaimer": "Vous ne serez pas facturé avant une heure avant le début de votre rendez-vous.",
    "canceledNotCharged": "Vous n'avez pas été facturé en raison de l'annulation de ce rendez-vous.",
    "canceledCharged": "Vous avez été facturé malgré l'annulation du rendez-vous en raison de la politique d'annulation de {{shopName}}."
  },
  "ViewReservationErrorFallback": {
    "title": "Erreur de chargement de la réservation",
    "retry": "Réessayer",
    "takeMeHome": "Me ramener à l'accueil"
  },
  "ViewReservationShopInfo": {
    "getDirections": "Obtenir l'itinéraire",
    "accessibility": {
      "getDirections": "Obtenir l'itinéraire vers le salon",
      "mapPreview": "Aperçu de la carte de l'emplacement du salon"
    }
  },
  "ViewWaitlistContentWrapper": {
    "confirmation": {
      "title": "{{name}}, la liste d'attente est confirmée !",
      "titleGeneric": "La liste d'attente est confirmée !"
    },
    "header": {
      "available": "Un créneau est disponible pour {{barber}} le {{date}}",
      "expired": "La liste d'attente de {{barber}} pour le {{date}} a expiré",
      "removed": "Vous avez été retiré de la liste d'attente",
      "readyToBook": "Le rendez-vous avec {{barber}} pour le {{date}} est prêt à réserver"
    },
    "badge": {
      "waitingList": "Liste d'attente",
      "slotsAvailable": "{{count}} créneaux disponibles",
      "expired": "Liste d'attente expirée",
      "chooseTime": "Choisir un horaire",
      "chooseDifferentTime": "Choisir une autre date et heure"
    },
    "position": {
      "title": "Vous êtes en position {{position}}",
      "subtitle": "sur la liste d'attente pour {{name}}",
      "notify": "Nous vous informerons lorsqu'un créneau se libère"
    },
    "actions": {
      "book": "Réserver",
      "reschedule": "Reprogrammer",
      "leaveWaitlist": "Quitter la liste d'attente"
    },
    "accessibility": {
      "close": "Fermer",
      "closeHint": "Ferme les détails de la liste d’attente"
    },
    "errors": {
      "bookingFailed": "Échec de la réservation. Veuillez réessayer.",
      "rescheduleFailed": "Échec de la reprogrammation. Veuillez réessayer.",
      "slotsFetchFailed": "Échec du chargement des horaires disponibles. Veuillez réessayer."
    }
  },
  "LeaveWaitlistModal": {
    "title": "Quitter la liste d'attente ?",
    "message": "Vous perdrez votre place sur la liste d'attente. Vous pouvez vous réinscrire à tout moment.",
    "leave": "Quitter la liste d'attente",
    "leaving": "Départ en cours...",
    "keep": "Garder ma place",
    "accessibility": {
      "close": "Fermer",
      "leave": "Quitter la liste d'attente",
      "keep": "Garder ma place",
      "closeHint": "Ferme cette boîte de dialogue"
    },
    "errors": {
      "leaveFailed": "Impossible de quitter la liste d'attente. Veuillez réessayer."
    }
  },
  "ViewWaitlistCard": {
    "duration": "Durée",
    "durationValue": "{{minutes}} min",
    "date": "Date",
    "time": "Horaire",
    "tip": "Pourboire",
    "total": "Prix total",
    "chooseTime": "Choisir un horaire",
    "chooseDifferentTime": "Choisir une autre date et heure"
  },
  "WaitlistTimeSlotsSheet": {
    "title": "Horaires disponibles pour le {{date}}",
    "confirm": "Confirmer"
  },
  "WaitlistRescheduleSheet": {
    "title": "Choisir une autre date et heure",
    "confirm": "Confirmer"
  },
  "WaitlistRescheduleScreen": {
    "title": "Choisir un horaire",
    "rescheduleButton": "Confirmer",
    "successMessage": "Replanifié avec succès",
    "errorMessage": "Échec de la replanification. Veuillez réessayer.",
    "noTimeSelected": "Veuillez sélectionner un horaire"
  },
  "EditPhoneNumberBottomSheet": {
    "editTitle": "Modifier le numéro de téléphone",
    "setTitle": "Définir le numéro de téléphone",
    "phoneLabel": "TÉLÉPHONE",
    "phonePlaceholder": "Entrez le numéro de téléphone",
    "sendCodeButton": "Envoyer le code",
    "verifyTitle": "Vérifiez votre numéro de téléphone",
    "verifyDescription": "Nous avons envoyé un code de vérification à 6 chiffres au numéro se terminant par {{last4}}",
    "sendingCode": "Envoi du code de vérification...",
    "codeSent": "Code envoyé",
    "validCode": "Code vérifié",
    "invalidCode": "Code de vérification invalide. Veuillez réessayer.",
    "sendCodeError": "Échec de l'envoi du code de vérification",
    "sendCodeErrorDescription": "Veuillez réessayer ou contacter le support si le problème persiste.",
    "enterCodeLabel": "ENTREZ LE CODE",
    "resendCodeButton": "Renvoyer le code",
    "otpCode": "Code",
    "didNotReceiveText": "Vous n'avez rien reçu ? Réessayez.",
    "accessibility": {
      "closeButton": "Fermer la modification du numéro de téléphone",
      "closeButtonHint": "Annuler la modification et fermer",
      "phoneInput": "Saisie du numéro de téléphone",
      "phoneInputHint": "Entrez votre numéro de téléphone",
      "sendCodeButton": "Envoyer le code",
      "sendCodeButtonHint": "Envoyer un code de vérification à 6 chiffres sur votre téléphone",
      "saveButtonHint": "Enregistrer les modifications de votre numéro de téléphone",
      "otpInput": "Saisie du code de vérification",
      "otpInputHint": "Entrez le code de vérification à 6 chiffres",
      "resendButton": "Renvoyer le code de vérification",
      "resendButtonHint": "Renvoyer le code de vérification sur votre téléphone"
    }
  },
  "CancelOrderModal": {
    "title": "Annuler la commande",
    "message": "Êtes-vous sûr de vouloir annuler cette commande ? Veuillez noter que cela annulera tous les rendez-vous associés.",
    "cancel": "Annuler",
    "canceling": "Annulation...",
    "keep": "Conserver",
    "accessibility": {
      "close": "Fermer la fenêtre d'annulation de commande",
      "cancel": "Annuler la commande",
      "keep": "Conserver la commande",
      "closeHint": "Ferme cette boîte de dialogue"
    }
  },
  "ConfirmBookingBottomSheet": {
    "title": "Confirmer la réservation",
    "haveAccount": "Vous avez un compte ?",
    "signIn": "Se connecter",
    "paymentMethod": "Mode de paiement",
    "applePay": "Apple Pay",
    "googlePay": "Google Pay",
    "creditOrDebitCard": "Carte ou compte bancaire",
    "payInPerson": "Payer en personne",
    "cashApp": "Cash App",
    "buyNowPayLaterWith": "Achetez maintenant, payez plus tard avec {{provider}}",
    "bnplProvider": {
      "klarna": "Klarna",
      "affirm": "Affirm",
      "afterpay_clearpay": "Afterpay"
    },
    "payNow": "Payer maintenant",
    "payLater": "Payer plus tard",
    "afterpay": "Afterpay",
    "summary": "Récapitulatif",
    "services": "Services",
    "tips": "Pourboires",
    "taxes": "Taxes et frais",
    "total": "Total",
    "addPromoCode": "Ajouter un code",
    "promoCode": "Code promo",
    "giftCard": "Carte cadeau",
    "membership": "Abonnement",
    "taxesLabel": "Taxes",
    "feesLabel": "Frais",
    "feesDescription": "Il s'agit de frais de commodité perçus par SQUIRE. Le montant varie en fonction des services dans votre panier.",
    "feesDescriptionWithBarbershop": "Il s'agit de frais de commodité perçus par SQUIRE et votre salon.",
    "waitlistFeeLabel": "Frais de liste d'attente",
    "waitlistFeeDescription": "Ces frais sont facturés lors de l'inscription sur la liste d'attente.",
    "book": "Réserver",
    "booking": "Réservation",
    "joinWaitlist": "Inscrivez-moi sur la liste d'attente",
    "paymentRequiredForWaitlist": "Une carte enregistrée est requise pour rejoindre la liste d'attente.",
    "yourCardWillBeChargedToday": "Votre carte sera débitée aujourd'hui",
    "legalText": "En réservant un rendez-vous, vous acceptez les",
    "termsOfService": "Conditions d'utilisation",
    "and": "et la",
    "privacyPolicy": "Politique de confidentialité",
    "userInformation": {
      "title": "Vos informations",
      "firstNameLabel": "PRÉNOM",
      "firstNamePlaceholder": "Prénom *",
      "lastNameLabel": "NOM",
      "lastNamePlaceholder": "Nom *",
      "phoneLabel": "TÉLÉPHONE",
      "phonePlaceholder": "Téléphone *",
      "emailLabel": "EMAIL",
      "emailPlaceholder": "Email *",
      "validation": {
        "firstNameRequired": "Le prénom est requis",
        "firstNameInvalid": "Le prénom ne peut pas contenir de chiffres",
        "lastNameRequired": "Le nom est requis",
        "lastNameInvalid": "Le nom ne peut pas contenir de chiffres",
        "phoneInvalid": "Veuillez entrer un numéro de téléphone valide",
        "emailInvalid": "Veuillez entrer une adresse email valide",
        "emailRequired": "L'email est requis",
        "paymentMethodRequired": "Veuillez sélectionner un mode de paiement"
      },
      "accessibility": {
        "firstNameInput": "Prénom",
        "lastNameInput": "Nom",
        "phoneInput": "Numéro de téléphone",
        "phoneInputHint": "Entrez votre numéro de téléphone avec l'indicatif pays",
        "emailInput": "Adresse email"
      }
    },
    "accessibility": {
      "closeButton": "Fermer la confirmation de réservation",
      "closeButtonHint": "Fermer la feuille inférieure de confirmation de réservation",
      "shopImage": "Photo de {{name}}",
      "paymentMethod": "Mode de paiement {{method}}",
      "paymentMethodHint": "Sélectionner {{method}} comme mode de paiement",
      "bookButton": "Réserver le rendez-vous",
      "bookButtonHint": "Confirmer et réserver votre rendez-vous",
      "loading": "Chargement"
    }
  },
  "RescheduleAppointmentScreen": {
    "title": "Reprogrammer",
    "currentAppointment": "Rendez-vous actuel",
    "minutesAbbreviation": "min",
    "newAppointment": "Nouveau rendez-vous",
    "selectNewTime": "Sélectionnez une nouvelle date et heure",
    "rescheduleButton": "Reprogrammer",
    "cancelButton": "Annuler",
    "successMessage": "Rendez-vous reprogrammé avec succès",
    "error": "Échec du chargement des données du rendez-vous. Veuillez réessayer.",
    "tryAgain": "Réessayer",
    "errorMessage": "Échec de la reprogrammation du rendez-vous",
    "errorDescription": "Veuillez réessayer ou contacter le support",
    "sameTimeError": "Veuillez sélectionner un horaire différent",
    "noTimeSelected": "Veuillez sélectionner un nouvel horaire",
    "pastTimeError": "Impossible de sélectionner un horaire dans le passé",
    "loadingSchedule": "Chargement des horaires disponibles...",
    "noAvailableTimes": "Aucun horaire disponible pour cette date",
    "barberDoesNotAllowReschedule": "Ce coiffeur n'autorise pas la reprogrammation dans ce délai",
    "timeSlotUnavailable": "Cet horaire n'est plus disponible",
    "cannotReschedulePast": "Impossible de reprogrammer les rendez-vous passés",
    "accessibility": {
      "rescheduleButton": "Reprogrammer le rendez-vous à l'horaire sélectionné",
      "backButton": "Annuler et retourner"
    }
  },
  "CashAppBottomSheet": {
    "title": "Scanner avec Cash App",
    "timeRemaining": "Temps restant",
    "instructions": "Ouvrez Cash App sur votre téléphone et scannez ce code QR pour finaliser votre paiement",
    "troubleshooting": "Des problèmes ? Assurez-vous que Cash App est installé et que vous êtes connecté.",
    "qrCodeExpired": "Code QR expiré",
    "qrCodeExpiredDescription": "Le code QR a expiré. Veuillez cliquer sur Réessayer pour générer un nouveau code QR.",
    "retry": "Réessayer",
    "openInCashApp": "ou cliquez ici pour ouvrir Cash App",
    "error": {
      "loadingQRCode": "Échec du chargement du code QR. Veuillez réessayer."
    },
    "accessibility": {
      "closeButton": "Fermer le paiement Cash App",
      "closeButtonHint": "Fermer le scanner de code QR Cash App",
      "qrCode": "Code QR de paiement Cash App"
    }
  },
  "CheckoutFormBottomSheet": {
    "cardDetails": "Détails de la carte",
    "cardOnFileRequired": "Carte enregistrée requise",
    "book": "Réserver",
    "booking": "Réservation",
    "buyGiftCard": "Acheter une carte-cadeau",
    "buyingGiftCard": "Achat de la carte-cadeau",
    "pay": "Payer",
    "joinWaitlist": "Inscrivez-moi sur la liste d'attente"
  },
  "LegalBottomSheet": {
    "termsTitle": "Conditions d'utilisation",
    "privacyTitle": "Politique de confidentialité",
    "errorTitle": "Échec du chargement du contenu",
    "errorMessage": "Veuillez vérifier votre connexion Internet et réessayer.",
    "accessibility": {
      "closeButton": "Fermer",
      "closeButtonHint": "Ferme le document légal et retourne à la vue précédente"
    }
  },
  "ReferralBanner": {
    "accessibilityLabel": "Devenez ambassadeur de marque et gagnez de l'argent",
    "eyebrow": "Ambassadeur de marque",
    "headline": "Devenez ambassadeur\nde marque et\ngagnez de l'argent !"
  },
  "ReferralWebViewScreen": {
    "title": "Programme de parrainage",
    "loadingLabel": "Chargement du programme de parrainage"
  },
  "CookieConsent": {
    "thisSiteUsesCookie": "Ce site utilise des cookies",
    "manageYourPrivacyChoices": "Gérez vos choix de confidentialité",
    "here": "ici",
    "accept": "Accepter",
    "consentTab": "Consentement",
    "detailsTab": "Détails",
    "aboutTab": "À propos",
    "consentContent": "Nous utilisons des cookies pour améliorer l'expérience utilisateur et analyser le trafic du site. Pour ces raisons, nous pouvons également partager des informations sur votre utilisation de notre site avec nos partenaires d'analyse. En cliquant sur Tout autoriser, vous consentez à stocker sur votre appareil toutes les technologies décrites dans notre Politique de cookies. Vous pouvez modifier vos paramètres de cookies en cliquant sur Personnaliser.",
    "detailsContent": "Détails",
    "aboutContent": "Les cookies sont de petits fichiers texte que les sites web peuvent utiliser pour rendre l'expérience utilisateur plus efficace. La loi stipule que nous pouvons stocker des cookies sur votre appareil s'ils sont strictement nécessaires au fonctionnement de ce site. Pour tous les autres types de cookies, nous avons besoin de votre permission. Ce site utilise différents types de cookies. Certains cookies sont placés par des services tiers qui apparaissent sur nos pages. Pour plus d'informations sur notre utilisation des cookies, vous pouvez consulter notre Politique de cookies. Consultez notre Politique de cookies. En savoir plus sur qui nous sommes, comment vous pouvez nous contacter et comment nous traitons les données personnelles dans notre Politique de confidentialité. Consultez notre",
    "privacyPolicyLink": "Politique de confidentialité",
    "denyButton": "Refuser",
    "rejectButton": "Ignorer",
    "allowSelection": "Autoriser la sélection",
    "manage": "Gérer",
    "allowAllButton": "Tout autoriser"
  },
  "CookieConsentDetails": {
    "trackerCount": "{{count}} trackers",
    "trackerCount_one": "{{count}} tracker",
    "trackerCount_other": "{{count}} trackers",
    "toggleCategory": "Basculer {{category}}",
    "denyButton": "Refuser",
    "allowSelectionButton": "Autoriser la sélection",
    "allowAllButton": "Tout autoriser",
    "backButton": "Retour",
    "expiry": "Expiration",
    "type": "Type",
    "month": "{{count}} mois",
    "month_one": "{{count}} mois",
    "month_other": "{{count}} mois",
    "year": "{{count}} an",
    "year_one": "{{count}} an",
    "year_other": "{{count}} ans",
    "minute": "{{count}} minute",
    "minute_one": "{{count}} minute",
    "minute_other": "{{count}} minutes",
    "hour": "{{count}} heure",
    "hour_one": "{{count}} heure",
    "hour_other": "{{count}} heures",
    "categories": {
      "necessary": {
        "title": "Nécessaires",
        "description": "Nous utilisons des cookies nécessaires pour rendre notre site web le plus convivial possible, permettant la navigation de l'expérience de réservation, la planification des services et les paiements."
      },
      "statistical": {
        "title": "Statistiques",
        "description": "Nous utilisons des cookies statistiques pour nous aider à comprendre comment vous interagissez avec notre site web en collectant et en rapportant des informations de manière anonyme."
      }
    },
    "trackers": {
      "stripe": {
        "name": "Stripe",
        "description": "Nous utilisons Stripe pour le traitement des paiements et stockons ses cookies pour assurer un fonctionnement correct.",
        "__stripe_sid": {
          "description": "Défini par Stripe pour la prévention de la fraude."
        },
        "__stripe_mid": {
          "description": "Défini par Stripe pour la prévention de la fraude."
        },
        "m": {
          "description": "Défini par Stripe pour la prévention de la fraude."
        },
        "cookie-perms": {
          "description": "Stocke vos préférences de consentement aux cookies."
        }
      },
      "google": {
        "name": "Google",
        "description": "Nous utilisons Google pour divers services tels que Google Pay et Google Calendar et stockons ses cookies pour assurer un fonctionnement correct.",
        "G_ENABLED_IDPS": {
          "description": "Défini par Google pour activer l'authentification unique."
        },
        "NID": {
          "description": "Défini pour le bon fonctionnement des services Google."
        },
        "1P_JAR": {
          "description": "Défini pour le bon fonctionnement des services Google."
        },
        "SID": {
          "description": "Défini pour le bon fonctionnement des services Google."
        },
        "SSID": {
          "description": "Défini pour le bon fonctionnement des services Google."
        },
        "HSID": {
          "description": "Défini pour le bon fonctionnement des services Google."
        },
        "SIDCC": {
          "description": "Défini pour le bon fonctionnement des services Google."
        },
        "APISID": {
          "description": "Défini pour le bon fonctionnement des services Google."
        },
        "__Secure-1PSID": {
          "description": "Défini pour le bon fonctionnement des services Google."
        },
        "__Secure-1PAPISID": {
          "description": "Défini pour le bon fonctionnement des services Google."
        },
        "__Secure-3PAPISID": {
          "description": "Défini pour le bon fonctionnement des services Google."
        },
        "__Secure-3PSID": {
          "description": "Défini pour le bon fonctionnement des services Google."
        },
        "__Secure-3PSIDCC": {
          "description": "Défini pour le bon fonctionnement des services Google."
        },
        "__Secure-APISID": {
          "description": "Défini pour le bon fonctionnement des services Google."
        },
        "__Secure-HSID": {
          "description": "Défini pour le bon fonctionnement des services Google."
        },
        "__Secure-SSID": {
          "description": "Défini pour le bon fonctionnement des services Google."
        }
      },
      "cloudflare": {
        "name": "Cloudflare",
        "description": "Nous utilisons Cloudflare pour garantir une expérience utilisateur agréable et stockons divers cookies pour maximiser les ressources réseau, gérer le trafic et protéger nos sites du trafic malveillant.",
        "__cf_bm": {
          "description": "Défini pour le bon fonctionnement de la fonctionnalité de gestion des bots ou de lutte contre les bots."
        }
      },
      "google-analytics": {
        "name": "Google Analytics",
        "description": "Nous utilisons Google Analytics pour comprendre comment les visiteurs interagissent avec notre site web.",
        "DV": {
          "description": "Défini par Google Analytics pour collecter des informations sur la façon dont les visiteurs utilisent notre site."
        },
        "OTZ": {
          "description": "Défini par Google Analytics pour collecter des informations sur la façon dont les visiteurs utilisent notre site."
        },
        "_gat": {
          "description": "Défini par Google Analytics pour limiter le taux de requêtes."
        },
        "_gid": {
          "description": "Défini par Google Analytics pour distinguer les utilisateurs."
        }
      },
      "facebook-pixel": {
        "name": "Facebook Pixel",
        "description": "Nous utilisons Facebook Pixel pour mesurer l'efficacité publicitaire et diffuser des publicités pertinentes.",
        "_fbp": {
          "description": "Défini par Facebook pour diffuser de la publicité et suivre les conversions."
        },
        "fr": {
          "description": "Défini par Facebook pour diffuser de la publicité et mesurer les performances des annonces."
        },
        "datr": {
          "description": "Défini par Facebook pour identifier les navigateurs web à des fins de sécurité."
        }
      }
    }
  },
  "DeleteServiceConfirmationBottomSheet": {
    "removeService": {
      "subtitle": "Supprimer ce service supprimera également les compléments suivants, car ils nécessitent un service principal.",
      "confirm": "Supprimer le service et les compléments",
      "dismiss": "Tout conserver"
    }
  },
  "BnplBottomSheet": {
    "title": "Achetez maintenant, payez plus tard",
    "stripeNotReady": "Le service de paiement n'est pas disponible. Veuillez réessayer.",
    "failedToCreateIntent": "Impossible de démarrer le paiement. Veuillez réessayer.",
    "missingCustomerInfo": "Impossible de traiter le paiement. Veuillez réessayer.",
    "missingCustomer": "Les informations client sont manquantes. Veuillez réessayer.",
    "next": "Suivant"
  },
  "BnplReturnScreen": {
    "loading": "Traitement en cours",
    "sessionExpired": "Votre session a expiré",
    "error": "Une erreur s'est produite",
    "cancelledToast": "Le paiement a été annulé ou a échoué",
    "goHome": "Retour à l'accueil"
  },
  "ManageNotificationsBottomSheet": {
    "title": "Gérer les notifications",
    "save": "Enregistrer",
    "confirm": "Confirmation",
    "reschedule": "Reprogrammer",
    "cancel": "Annulation",
    "errorMessage": "Échec de la mise à jour des notifications. Veuillez réessayer.",
    "pushNotifications": "Notifications push",
    "pushEnabled": "Activé",
    "pushDisabled": "Désactivé"
  },
  "NotificationSectionRow": {
    "phone": "SMS",
    "email": "E-mail",
    "push": "Push"
  },
  "CashAppReturnScreen": {
    "loading": "Traitement en cours",
    "sessionExpired": "Votre session a expiré. Veuillez réessayer.",
    "error": "Une erreur s'est produite. Veuillez réessayer.",
    "cancelledToast": "Le paiement a été annulé.",
    "goHome": "Retour à l'accueil"
  },
  "AccountDeletion": {
    "choice": {
      "title": "Souhaitez-vous désactiver ou supprimer votre compte ?",
      "disable": {
        "title": "Désactiver le compte",
        "description": "Nous désactiverons votre (vos) compte(s) sur les applications alimentées par Squire."
      },
      "delete": {
        "title": "Supprimer le compte",
        "description": "Nous effacerons toutes vos données de toutes les applications et services alimentés par Squire."
      },
      "cancel": "Annuler",
      "continue": "Continuer"
    },
    "disable": {
      "header": "Êtes-vous sûr de vouloir désactiver votre compte ?",
      "cards": {
        "0": {
          "title": "Votre compte sera désactivé",
          "description": "Nous désactiverons votre compte Squire et vous ne pourrez plus vous connecter à aucun service alimenté par Squire."
        },
        "1": {
          "title": "Les barbiers peuvent toujours accéder à vos données",
          "description": "Votre barbier peut toujours vous contacter pour des rendez-vous ou vous envoyer des messages marketing."
        },
        "2": {
          "title": "Les rendez-vous futurs ne seront pas annulés",
          "description": "Tous vos rendez-vous futurs et abonnements resteront actifs."
        },
        "3": {
          "title": "Il est possible de restaurer votre compte",
          "description": "Pour restaurer votre compte, veuillez contacter techsupport@getsquire.com"
        }
      },
      "primary": "Désactiver le compte",
      "secondary": "Conserver le compte"
    },
    "delete": {
      "header": "Êtes-vous sûr de vouloir supprimer votre compte ?",
      "cards": {
        "0": {
          "title": "Toutes vos données seront supprimées",
          "description": "Nous effacerons toutes vos données de toutes les applications et services Squire, y compris les applications de barbiers alimentées par Squire."
        },
        "1": {
          "title": "Non responsable des contacts futurs",
          "description": "Nous ne sommes pas responsables si votre barbier continue de vous contacter de façon indépendante."
        },
        "2": {
          "title": "Les rendez-vous seront annulés",
          "description": "Tous vos rendez-vous futurs et abonnements seront annulés. La politique d'annulation de votre barbier s'applique toujours."
        },
        "3": {
          "title": "C'est définitif",
          "description": "Une fois supprimé, cela ne peut pas être annulé."
        }
      },
      "primary": "Supprimer le compte",
      "secondary": "Conserver le compte"
    },
    "toast": {
      "successDisabled": "Votre compte a été désactivé avec succès",
      "successDeleted": "Votre compte a été supprimé avec succès",
      "error": "Une erreur s'est produite"
    }
  },
  "StandbyRegistrationScreen": {
    "branding": {
      "headline": "Rejoignez la liste d'attente.",
      "poweredBy": "Proposé par"
    },
    "closed": {
      "title": "La liste d'attente est fermée.",
      "bookButton": "Réserver un prochain rendez-vous",
      "bookButtonHint": "Ouvre la page de réservation de ce salon"
    },
    "enterPhone": {
      "title": "Saisissez votre téléphone",
      "subtitle": "Nous allons vérifier si vous avez déjà un compte.",
      "phoneLabel": "Téléphone",
      "placeholder": "06 12 34 56 78",
      "invalid": "Saisissez un numéro de téléphone valide"
    },
    "footnote": {
      "sms": "En continuant, vous acceptez de recevoir des messages texte de SQUIRE au numéro fourni. Des frais de messagerie et de données peuvent s'appliquer.",
      "legal": "En continuant, vous acceptez les <tosLink>Conditions d'utilisation</tosLink> et la <privacyLink>Politique de confidentialité</privacyLink>, y compris la réception de messages transactionnels et marketing de SQUIRE."
    },
    "otp": {
      "title": "Saisissez le code",
      "subtitle": "Saisissez le code à 6 chiffres que nous avons envoyé à votre téléphone.",
      "error": "Ce code n'a pas fonctionné. Réessayez.",
      "expired": "Ce code a expiré. Demandez-en un nouveau ci-dessous."
    },
    "confirmSession": {
      "title": "Continuer en tant que {{firstName}} ?",
      "subtitle": "Nous avons trouvé une session existante sur cet appareil.",
      "confirm": "Oui, c'est moi",
      "notYou": "Ce n'est pas vous ?",
      "exitTitle": "Quitter la liste d'attente ?",
      "exitSubtitle": "Revenir en arrière vous fait quitter la liste d'attente. Vous devrez vérifier à nouveau votre numéro de téléphone pour recommencer.",
      "exitStay": "Rester et continuer",
      "exitLeave": "Quitter et recommencer"
    },
    "details": {
      "title": "Ajoutez vos informations",
      "eyebrow": "On dirait que vous êtes nouveau ici",
      "firstName": "Prénom",
      "firstNamePlaceholder": "Derek",
      "lastName": "Nom",
      "lastNamePlaceholder": "Jackson",
      "email": "E-mail",
      "emailPlaceholder": "email@squire.com",
      "phone": "Téléphone",
      "birthday": "Anniversaire",
      "birthdayPlaceholder": "MM/DD/AAAA",
      "avatarLabel": "Ajouter une photo de profil",
      "errors": {
        "birthdayRequired": "Saisissez votre date de naissance",
        "birthdayInvalid": "Saisissez une date valide"
      }
    },
    "cta": {
      "continue": "Continuer",
      "back": "Retour",
      "close": "Fermer"
    },
    "unavailable": {
      "title": "Cette page n'est pas disponible",
      "genericBody": "Cette liste d'attente n'est pas disponible pour le moment.",
      "disabledBody": "Ce salon n'accepte pas les inscriptions sur liste d'attente pour le moment.",
      "errorTitle": "Une erreur s'est produite",
      "errorBody": "Nous n'avons pas pu charger cette page.",
      "retry": "Réessayer"
    },
    "errors": {
      "throttled": "Trop de tentatives. Patientez un instant et réessayez.",
      "submit": "Une erreur s'est produite. Veuillez réessayer."
    },
    "accessibility": {
      "backButton": "Retour",
      "backButtonHint": "Revient à l'étape précédente",
      "closeButton": "Fermer",
      "closeButtonHint": "Ferme la vérification et revient à l'étape du téléphone",
      "phoneInput": "Numéro de téléphone",
      "phoneInputHint": "Saisissez votre numéro de mobile pour recevoir un code de vérification",
      "phoneContinueButton": "Continuer",
      "phoneContinueButtonHint": "Envoie un code de vérification à votre téléphone",
      "otpInput": "Code de vérification",
      "otpInputHint": "Saisissez le code à 6 chiffres envoyé à votre téléphone",
      "otpContinueButton": "Vérifier",
      "otpContinueButtonHint": "Vérifie le code que vous avez saisi",
      "detailsContinueButton": "Continuer",
      "detailsContinueButtonHint": "Vous inscrit sur la liste d'attente avec vos informations",
      "birthdayInput": "Date de naissance",
      "birthdayInputHint": "Saisissez votre date de naissance en mois, jour et année",
      "confirmButton": "Continuer",
      "confirmButtonHint": "Continue avec votre compte connecté",
      "notYouButton": "Ce n'est pas vous ?",
      "notYouButtonHint": "Vous déconnecte pour utiliser un autre numéro de téléphone",
      "exitStayButton": "Rester et continuer",
      "exitStayButtonHint": "Reste dans la liste d'attente et continue",
      "exitLeaveButton": "Quitter et recommencer",
      "exitLeaveButtonHint": "Quitte la liste d'attente ; vous devrez vérifier à nouveau votre numéro de téléphone",
      "retryButton": "Réessayer",
      "retryButtonHint": "Recharge la page de liste d'attente"
    }
  },
  "StandbyStylistScreen": {
    "title": "Sélectionnez un styliste",
    "anyTitle": "N'importe quel professionnel",
    "anySubtitle": "Attribution automatique selon la disponibilité",
    "continue": "Continuer",
    "error": "Impossible de charger les stylistes.",
    "retry": "Réessayer",
    "empty": "Aucun styliste disponible.",
    "accessibility": {
      "continueButton": "Continuer",
      "continueButtonHint": "Passe à la sélection du service",
      "retryButton": "Réessayer",
      "retryButtonHint": "Recharge la liste des stylistes"
    }
  },
  "StandbySummaryScreen": {
    "title": "Récapitulatif",
    "stylistLabel": "Coiffeur",
    "serviceLabel_one": "Service",
    "serviceLabel_other": "Services",
    "priceLabel": "Prix",
    "durationLabel": "Durée",
    "error": "Impossible de charger votre récapitulatif",
    "retry": "Réessayer",
    "join": "Rejoindre la liste d'attente",
    "joinError": "Impossible de vous inscrire à la liste d'attente. Réessayez.",
    "alreadyOnListToast": "Vous êtes déjà sur la liste d'attente d'aujourd'hui.",
    "accessibility": {
      "joinButton": "Rejoindre la liste d'attente",
      "joinButtonHint": "Envoie votre demande d'inscription",
      "retryButton": "Réessayer",
      "retryButtonHint": "Recharge votre récapitulatif"
    }
  },
  "StandbyServiceScreen": {
    "title": "Sélectionnez des services",
    "searchPlaceholder": "Rechercher des services",
    "categoryAll": "Tous",
    "categoryCount": "{{name}} ({{count}})",
    "continue": "Continuer",
    "empty": "Aucun service disponible.",
    "filteredEmpty": "Aucun service ne correspond à votre recherche.",
    "error": "Impossible de charger les services.",
    "retry": "Réessayer",
    "durationMinutes": "{{count}} min",
    "durationHours": "{{count}} h",
    "durationHourMinutes": "{{hours}} h {{minutes}} min",
    "accessibility": {
      "continueButton": "Continuer",
      "continueButtonHint": "Passe au récapitulatif",
      "retryButton": "Réessayer",
      "retryButtonHint": "Recharge la liste des services"
    }
  },
  "StandbyEntriesScreen": {
    "title": "Liste d'attente",
    "closeButton": "Fermer la liste d'attente",
    "closeButtonHint": "Retourne à l'écran précédent",
    "subtitle": {
      "any": "En attente de tout professionnel",
      "waitingFor": "En attente de {{name}}"
    },
    "offer": "{{time}} avec {{name}}",
    "empty": "Vous n'êtes sur aucune liste d'attente",
    "today": "Aujourd'hui",
    "tomorrow": "Demain",
    "errorToast": "Nous n'avons pas pu charger votre liste d'attente. Réessayez.",
    "accessibility": {
      "row": "Ouvre cette demande de liste d'attente",
      "countdown": "L'offre expire dans {{time}}"
    }
  },
  "StandbyEntryStatusScreen": {
    "waiting": {
      "title": "Vous êtes sur la liste",
      "subtitle": "Dès qu'une place se libère, nous vous préviendrons pour que vous puissiez accepter et payer, ou refuser et rester sur la liste."
    },
    "offer": {
      "title": "Nous avons trouvé une place pour vous",
      "subtitle": "Acceptez pour réserver et procéder au paiement, ou refusez pour rester sur la liste et attendre une autre disponibilité.",
      "countdown": "En attente de votre réponse ({{time}})",
      "dateLabel": "Date",
      "timeLabel": "Heure",
      "professionalLabel": "Professionnel",
      "dateToday": "Aujourd'hui, {{date}}",
      "dateTomorrow": "Demain, {{date}}",
      "accept": "Accepter et payer",
      "decline": "Refuser et rester sur la liste"
    },
    "declined": {
      "heading": "Vous êtes sur la liste",
      "bannerTitle": "Vous êtes toujours sur la liste d'attente",
      "bannerBody": "Nous continuerons à surveiller une autre disponibilité."
    },
    "expired": {
      "bannerTitle": "Cette place n'est plus disponible",
      "bannerBody": "La place a expiré ou a été annulée. Nous continuerons à en chercher une autre."
    },
    "dayEnded": {
      "title": "Aucune place aujourd'hui",
      "body": "Pas de chance aujourd'hui, mais votre prochaine coupe n'est pas loin. Réservez la prochaine date disponible ou inscrivez-vous sur la liste d'attente de demain.",
      "bookCta": "Réserver la prochaine date disponible",
      "joinCta": "Rejoindre la liste de demain"
    },
    "error": "Une erreur s'est produite",
    "retry": "Réessayer",
    "summaryLabel": "Récapitulatif",
    "unpaid": "Non payé",
    "servicesLabel_one": "Service",
    "servicesLabel_other": "Services",
    "stylistLabel": "Coiffeur",
    "joinedForLabel": "Inscrit sur la liste pour le",
    "accessibility": {
      "retryButton": "Réessayer",
      "retryButtonHint": "Recharge votre demande de liste d'attente",
      "leaveButton": "Quitter la liste d'attente",
      "leaveButtonHint": "Ouvre une confirmation pour quitter la liste d'attente",
      "acceptButtonHint": "Ouvre le paiement pour ce rendez-vous",
      "declineButtonHint": "Ouvre une confirmation pour refuser cette offre",
      "dismissBanner": "Ignorer",
      "bookButtonHint": "Ouvre la réservation pour choisir votre prochain rendez-vous",
      "joinButtonHint": "Vous ajoute à la liste d'attente de demain",
      "joiningStandby": "Inscription sur la liste de demain",
      "joinStandbyError": "Nous n'avons pas pu vous ajouter à la liste de demain. Réessayez."
    },
    "leave": "Quitter la liste d'attente",
    "toast": {
      "left": "Vous avez quitté cette liste d'attente. Vous pouvez la rejoindre ci-dessous.",
      "postLeave": "Vous avez quitté la liste d'attente.",
      "expired": "Cette liste d'attente est clôturée pour aujourd'hui.",
      "booked": "Votre rendez-vous est confirmé. Consultez vos messages pour les détails.",
      "unavailable": "Ce lien n'est plus valide.",
      "invalidShop": "L'identifiant du salon que vous avez fourni n'est pas valide."
    }
  },
  "StandbyEntryDrawer": {
    "waiting": {
      "title": "Vous êtes sur la liste",
      "subtitle": "Dès qu'une place se libère, vous pouvez accepter et payer, ou refuser et continuer à attendre.",
      "pill": "En attente"
    },
    "offered": {
      "title": "Nous avons trouvé une place pour vous",
      "subtitle": "Acceptez et payez, ou refusez pour rester sur la liste et attendre une autre place.",
      "accept": "Accepter et payer",
      "decline": "Refuser et rester sur la liste"
    },
    "details": {
      "date": "Date",
      "duration": "Durée",
      "total": "Prix total"
    },
    "timePreference": {
      "morning": "Créneau du matin",
      "afternoon": "Créneau de l'après-midi",
      "evening": "Créneau du soir",
      "afterHours": "Hors des heures d'ouverture"
    },
    "banner": {
      "expired": {
        "title": "La place n'est plus disponible",
        "body": "La place a expiré ou a été annulée. Nous continuerons à en chercher une autre."
      },
      "declined": {
        "title": "Vous êtes toujours sur la liste d'attente",
        "body": "Nous continuerons à surveiller une autre place."
      },
      "dismiss": "Ignorer",
      "dismissHint": "Ignore cet avis"
    },
    "leave": "Quitter la liste d'attente",
    "accessibility": {
      "leaveButton": "Quitter la liste d'attente",
      "leaveButtonHint": "Ouvre une confirmation pour quitter la liste d'attente",
      "acceptButton": "Accepter et payer",
      "acceptButtonHint": "Ouvre le paiement pour ce rendez-vous",
      "declineButton": "Refuser et rester sur la liste",
      "declineButtonHint": "Refuse cette place et vous maintient sur la liste d'attente"
    }
  },
  "StandbyHomeCard": {
    "header": "Liste d'attente",
    "waiting": "En attente",
    "joinedOne": "Sur la liste chez {{shop}}.",
    "joinedMany": "Sur la liste dans {{count}} salons de barbier.",
    "offerOne": "{{stylist}} a une place à {{time}} chez {{shop}}.",
    "offerMany": "Vous avez des places dans {{count}} salons de barbier.",
    "accessibility": {
      "timeLeft": "{{time}} restant",
      "hintEntry": "Ouvre votre inscription en liste d'attente",
      "hintList": "Ouvre votre liste d'attente"
    }
  },
  "StandbyLeaveSheet": {
    "title": "Quitter la liste d'attente ?",
    "message": "Vous serez retiré de la liste et ne recevrez plus d'alertes de places disponibles.",
    "leave": "Quitter la liste d'attente",
    "close": "Fermer",
    "error": "Impossible de quitter la liste. Réessayez.",
    "accessibility": {
      "leaveButton": "Quitter la liste d'attente",
      "leaveButtonHint": "Vous retire de la liste d'attente",
      "closeButton": "Fermer",
      "closeButtonHint": "Vous garde sur la liste et ferme cette boîte de dialogue"
    }
  },
  "StandbyDeclineSheet": {
    "title": "Refuser cette place ?",
    "body": "Vous resterez sur la liste d'attente et nous continuerons à chercher une autre disponibilité.",
    "confirm": "Refuser et rester sur la liste",
    "close": "Garder cette place",
    "error": "Impossible de refuser l'offre. Réessayez.",
    "errorToast": "Cette offre n'est plus disponible.",
    "accessibility": {
      "confirmButton": "Refuser et rester sur la liste",
      "confirmButtonHint": "Refuse cette offre et vous garde sur la liste d'attente",
      "closeButton": "Garder cette place",
      "closeButtonHint": "Ferme cette boîte de dialogue et conserve l'offre"
    }
  },
  "StandbyCheckoutScreen": {
    "title": "Votre commande",
    "timeToPay": "Temps pour payer - ",
    "stylistLabel": "Coiffeur",
    "anyProfessionalLabel": "N'importe quel professionnel",
    "dateAndTimeLabel": "Date et heure",
    "dateAndTimeValue": "{{date}}, à {{time}}",
    "durationMinutes_one": "{{count}} min",
    "durationMinutes_other": "{{count}} min",
    "servicesLabel": "Services",
    "taxesAndFeesLabel": "Taxes et frais",
    "giftCard": "Carte-cadeau",
    "tipLabel": "Pourboire",
    "promoPlaceholder": "Ajoutez une carte-cadeau ou un code promo",
    "redeem": "Appliquer",
    "continue": "Continuer",
    "payInPerson": "Payer sur place",
    "paymentStepPlaceholder": "Mode de paiement",
    "promoInvalidError": "Ce code n'est pas valide.",
    "paymentFailedError": "Le paiement n'a pas abouti. Réessayez.",
    "cartMismatchError": "Votre commande a été mise à jour. Veuillez la vérifier.",
    "accessibility": {
      "countdown": "Temps pour payer, {{time}}",
      "stylistRow": "Coiffeur, {{name}}",
      "dateAndTimeRow": "Date et heure, {{date}}, {{duration}}",
      "serviceRow": "{{name}}, {{price}}",
      "promoInput": "Code promo ou carte-cadeau",
      "promoInputHint": "Saisissez un code promo ou le numéro d'une carte-cadeau",
      "redeemButtonHint": "Applique le code à votre commande",
      "removeCodeButton": "Supprimer le code",
      "removeCodeButtonHint": "Supprime le code appliqué de votre commande",
      "continueHint": "Passe à l'étape de paiement",
      "payInPersonHint": "Réserve ce rendez-vous pour payer sur place",
      "loading": "Chargement de votre commande",
      "closeButton": "Fermer",
      "closeButtonHint": "Ferme le paiement et revient à votre offre de liste d'attente"
    }
  },
  "StandbyPaymentMethod": {
    "title": "Mode de paiement",
    "payTotal": "Payer {{total}}",
    "confirm": "Confirmer",
    "walletError": "Le paiement n'a pas abouti. Réessayez.",
    "accessibility": {
      "closeButton": "Fermer",
      "closeButtonHint": "Retourne à votre commande sans perdre le panier",
      "payButtonHint": "Finalise votre paiement et réserve le rendez-vous",
      "backButton": "Retour",
      "backButtonHint": "Retourne à la liste des modes de paiement"
    }
  },
  "StandbyOrderConfirmedScreen": {
    "title": "Votre commande est confirmée !",
    "confirmationCodeLabel": "Code de confirmation",
    "addToCalendarLabel": "Ajouter au calendrier",
    "rescheduleAppointment": "Reporter le rendez-vous",
    "cancelAppointment": "Annuler le rendez-vous",
    "successFallback": {
      "title": "Votre réservation est confirmée !",
      "subtitle": "Votre réservation est confirmée. Nous rencontrons actuellement des difficultés pour charger tous les détails de la confirmation.",
      "toast": "Nous n'avons pas pu charger les détails de votre confirmation."
    },
    "shopCard": {
      "getDirections": "Itinéraire",
      "paymentDetailsLabel": "Détails du paiement",
      "chargeTodayDisclaimer": "Votre carte sera débitée aujourd'hui.",
      "paymentPendingBadge": "Paiement en attente",
      "paidBadge": "Payé",
      "payInPersonValue": "Payer sur place",
      "unpaidBadge": "Non payé"
    },
    "accessibility": {
      "mapPreview": "Aperçu de la carte de l'emplacement du salon",
      "confirmationCode": "Code de confirmation {{code}}",
      "addAppleCalendar": "Ajouter à Apple Calendar",
      "addGoogleCalendar": "Ajouter à Google Calendar",
      "rescheduleButtonHint": "Ouvre le processus pour reporter ce rendez-vous",
      "cancelButtonHint": "Ouvre une confirmation pour annuler ce rendez-vous",
      "closeButton": "Fermer",
      "closeButtonHint": "Ferme la confirmation"
    }
  },
  "CustomerNotificationView": {
    "unavailable": {
      "title": "Cette notification n'est plus disponible",
      "subtitle": "Le lien a peut-être expiré. Si vous avez encore besoin d'aide, contactez votre salon ou le support Squire."
    },
    "supportFooter": "Si ce message ne vous était pas destiné, contactez-nous à support@getsquire.com"
  },
  "StandbyWaitlistJoinedScreen": {
    "title": "{{name}}, vous êtes maintenant sur la liste d'attente",
    "leave": "Quitter la liste d'attente",
    "left": "Vous avez quitté la liste d'attente.",
    "throttled": "Trop de tentatives. Patientez un instant et réessayez.",
    "leaveError": "Impossible de quitter la liste. Réessayez.",
    "accessibility": {
      "close": "Fermer",
      "closeHint": "Retourne à la page de réservation du salon",
      "leaveHint": "Vous retire de cette liste d'attente immédiatement"
    }
  }
}
